import { Component, OnInit, NgZone, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ColDef, ColumnApi, GridApi, GridOptions, IRowNode, RowDataUpdatedEvent, ValueFormatterParams } from 'ag-grid-community';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CxoneObjectivesService, GroupTypes } from './cxone-objectives.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ToastrManager } from '@niceltd/cxone-components/toastr';
import { CxoneColumnHeaderRendererComponent } from 'src/app/cxone/admin/cxone-manage-metrics/ag-grid-components/cxone-column-header-renderer/cxone-column-header-renderer.component';
import { CxoneMetricNameCellRendererComponent } from 'src/app/cxone/admin/cxone-manage-metrics/ag-grid-components/cxone-metric-name-cell-renderer/cxone-metric-name-cell-renderer.component';
import { ObjectiveAssignmentDataObj, MetricObjectiveObj, ObjectiveProfileData, ObjectiveDetailsDataObj, ObjectiveAssignAtDataObj, ObjectivePalette, ObjectiveRangeValueObj, ObjectivesSaveObject, EmailTimeInterval, NotificationType, ObjectiveAlertDTO } from './cxone-objectives.model';
import { CxoneContextMenuCellRendererComponent } from './context-menu-cell-renderer/context-menu-cell-renderer.component';
import { cloneDeep } from 'lodash';
import { GroupDTO, GroupTypeDTO, User } from '../../../admin/user/user-admin.model';
import { CvCxAssignToolDTO, CvCxAssignToolOptions, CvCxEntities } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.models';
import { CvCxoneAssignToolComponent } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { MessageModalComponent } from '@niceltd/cxone-components/modal';
import { CustomTooltipCellRendererComponent } from './custom-tooltip-cell-renderer/custom-tooltip-cell-renderer.component';
import { OmnibarComponent } from '@niceltd/cxone-components/omnibar';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TagData, TagifySettings, TagifyService } from '@niceltd/cxone-components/tagify';
import { NotificationEditCellRendererComponent } from './notification-edit-cell-renderer/notification-edit-cell-renderer.component';
import { MetricSelectorComponent } from 'src/app/reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from 'src/app/reusables/metric-selector/metric-selector.service';
import { AgGridAngular } from 'ag-grid-angular';
import { DropdownModule } from '@niceltd/sol/dropdown';

type GroupSelection = "All" | "Specific";
type GroupType = "emp" | "rec";

interface NotificationTypeModel {
    type: string;
}

@Component({
    selector: 'cv-cxone-objectives',
    templateUrl: './cxone-objectives.component.html',
    styleUrls: ['./cxone-objectives.component.scss'],
    providers: [DialogService]
})
export class CxoneObjectivesComponent implements OnInit {
    @ViewChild('filters') filters: OmnibarComponent;
    @ViewChild('cxoneObjectivesGrid') agGrid: AgGridAngular;
    @ViewChild('cxoneObjectivesAlertGrid') agGridAlert: AgGridAngular;
    public searchValue: string = ""; // Landing search box value

    // Initial load values
    public assignmentData: ObjectiveAssignmentDataObj[] = [];
    public metricAbrDict: { [key: number]: MetricObjectiveObj } = {};
    public profilesInLevel: ObjectiveProfileData[][] = [];
    public userList: User[] = [];
    public selectedUsers: User[] = [];
    public activeUsers: User[] = [];

    public curObjectiveCount: number = 0; // Landing count label
    public gridOptions: GridOptions = null;
    public notificationGridOptions: GridOptions = null;
    public editPhase = 0; // 0 - Landing Page; 1 - Create/Edit; 2 - Performance Ranges & Notification
    public localization: Map<string, string>;

    private deleteTarget: ObjectiveAssignmentDataObj = null; // Value being considered for deletion

    public selectedObjective: ObjectiveAssignmentDataObj = null; // Specific card (or sub card) currently being viewed
    public selectedObjectiveList: ObjectiveAssignmentDataObj[] = []; // List of core card and any attached sub cards

    public objectiveNameError = 0; // See validateObjectiveName() for descriptions of each value
    public standardOptions: ObjectivePalette[] = null;  //previously []
    public selectedPalette: ObjectivePalette = null;
    public unsavedInputs: ObjectiveRangeValueObj[][] = [];
    public tabIndex: number = 0;
   
    public createTabChange: boolean = false;

    public preInputDisplays: string[][] = [[], [], []];
    public inputDisplays: string[][] = [[], [], []];
    public displayRedBorder: boolean[][] = [[], [], []];
    public firstInputLoad: boolean = false;
    public showSpinner: boolean = false;
    public duplicateNotification: boolean = false;
    public initNotificationList: ObjectiveAlertDTO[] = [];
    public curNotificationList: ObjectiveAlertDTO[] = [];
    private tempNotificationID: number = 0;

    public groupTypes: GroupTypes = null;   //previously { emp: [], rec: [] }
    public selectedGroupLevel: GroupTypeDTO = null; // Value mapped to the Group Level field
    public selectedEmailGrouplevel: GroupTypeDTO = null; // Group Level value for the Add/Edit Email notification
    public selectedEmailTimeInterval: EmailTimeInterval = null; // Selected interval for email notifications
    public selectedEmailTimeNumber: number = null; // The number of time intervals for notifications
    public selectedNotificationTypes: NotificationType[] = [];
    public selectedExternalEmails: TagData[] =[];
    public currentAlert: ObjectiveAlertDTO = null;
    public alertlevels: GroupTypeDTO[] = [];
    public tagifySettings: TagifySettings = {pattern: new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z]{2,4})+$/), editTags: {keepInvalid: false}, keepInvalidTags: true, texts: {duplicate: "", pattern:""}}; //"texts" refers to the hover title of invalid tags
    public normalizedMetricPlaceHolder: string = null;
    public isNewObjective: boolean = false;
    public isLoading: boolean = false;
    public levelDropdown = [];

    public selectGroupValue: GroupSelection = "All"; // Value mapped to the Select Groups field
    get filteredGroupTypes(): GroupTypes {
        return {
            emp: this.groupTypes.emp.filter(item => item.GroupTypeName != "Company" && item.GroupLevel >= this.selectedObjective?.assignments?.empLevelMin),
            rec: this.groupTypes.rec.filter(item => item.GroupTypeName != "Company" && item.GroupTypeName != "Point of Contact" && item.GroupLevel >= this.selectedObjective?.assignments?.recLevelMin)
        };
    }
    get allowedGroupTypes(): GroupTypes { //According to Metric min group levels
        return {
            emp: this.groupTypes.emp.filter(item => item.GroupLevel >= this.selectedObjective?.assignments?.empLevelMin),
            rec: this.groupTypes.rec.filter(item => item.GroupLevel >= this.selectedObjective?.assignments?.recLevelMin)
        };
    }
    get levelSelectOptions(): any[] {
        let listOfOptionObjects: any[] = [];

        if (!this.currentObjectiveRecGroupIsTopLevel) {
            this.filteredGroupTypes.rec.forEach(gType => {
                listOfOptionObjects.push({
                    ...gType,
                    category: this.getLocalizationString("Contact_Group", "Contact Group")
                });
            });
        }

        if (!this.currentObjectiveEmpGroupIsTopLevel) {
            this.filteredGroupTypes.emp.forEach(gType => {
                listOfOptionObjects.push({
                    ...gType,
                    category: this.getLocalizationString("Employee_Group", "Employee Group")
                });
            });
        }

        //Reverse for UI to show higher levels above lower levels
        listOfOptionObjects.reverse();
        return listOfOptionObjects;
    }
    get currentMetricType(): number { // -1 for none, 0 for Count, 1 for Normalized
        return this.metricAbrDict[this.selectedObjective.MetricID]?.MetricObjectiveType ?? -1;
    }
    get currentAssignedEmpGroups(): any[] {
        return this.selectedObjective?.assignments?.emp?.filter(item => item.GroupID != 0) ?? [];
    }
    get currentAssignedRecGroups(): any[] {
        return this.selectedObjective?.assignments?.rec?.filter(item => item.GroupID != 0) ?? [];
    }
    get currentObjectiveEmpGroupIsTopLevel(): boolean {
        return this.selectedObjective?.assignments?.empLevelMin == this.groupTypes.emp.length;
    }
    get currentObjectiveRecGroupIsTopLevel(): boolean {
        return this.selectedObjective?.assignments?.recLevelMin == this.groupTypes.rec.length;
    }
    get currentNumericType(): number { // -1 for none, 0 for Currency, 1 for Count, 2 for Percent, 3 for Time
        return this.metricAbrDict[this.selectedObjective.MetricID]?.NumericType ?? -1;
    }
    get currentTimeType(): number { // -1 or 0 for none, 1 for Seconds, 2 for Minutes, 3 for Hours, 4 for HH:MM:SS
        return this.metricAbrDict[this.selectedObjective.MetricID]?.TimeType ?? -1;
    }
    get selectedGroupLevelName(): string {
        return this.selectedGroupLevel?.GroupTypeName ? this.selectedGroupLevel.GroupTypeName + ' ' : '';
    }
    public NormalizedEmailTimeIntervalList: EmailTimeInterval[] = [];
    public CountEmailTimeIntervalList: EmailTimeInterval[] = [];

    public NotificationTypeList: NotificationType[] = [];

    private assignModal: DynamicDialogRef;
    public validationMessageModalRef: DynamicDialogRef = null;
    public previousRangeSelection: ObjectivePalette;
    public newRangeSelection: ObjectivePalette;
    public previousLevelSelection: GroupTypeDTO = null;
    public newLevelSelection: GroupTypeDTO = null;
    public displayRangeDropdown: boolean = true;
    public displayLevelDropdown: boolean = true;
    public groupTypeRadioButtons: boolean = true;
    public selectGroupsRadioButton: boolean = true;
    public secondViewSaveClicked: boolean = false;
    public tabActiveArray: boolean[] = [];
    public invalidObjectiveNames: string[] = [];
    public enableWeekAutoFill = false;
    public enableMonthAutoFill = false;
    public showBackValidationMessage: boolean = false;
    public originalEditObjectiveCopy: ObjectiveAssignmentDataObj[] = [];
    public inputBoxError: boolean = false;
    public previousSelectGroup: GroupSelection = "All";
    public showCancelValidationMessage: boolean = false;
    public notificationsLabel: string = "";
    public notificationSelectedLabel: any;
    public filterLevelSelection: GroupTypeDTO[] = [];
    public filterNotificationTypeSelection: NotificationTypeModel[] = [];
    public filterLevelOptions: GroupTypeDTO[] = [];
    public filterNotificationTypeOptions: NotificationTypeModel[] = [{type: "System"}, {type: "Email"}];
    public notificationSearchText: string = "";
    public modalRef: NgbModalRef;
    public omnibarSearchBarPlaceHolder: string = "";

    public firstSaveDisabled = true;
    public secondSaveDisabled = true;
    public metricDefinitionsData = null;


    @ViewChild('AddEditEmailNotification') AddEditEmailNotificationModal;

    positions = [
        [ [50, 80] ],
        [ [100, 140], [50, 40] ],
        [ [100, 140], [50, 80], [80, -85] ],
        [ [150, 135], [100, 140], [50, 80], [55, -60] ]
    ];

    positionsReverse = [
        [ [50, 80] ],
        [ [70, 120], [80, -85] ],
        [ [100, 140], [50, 80], [80, -85] ],
        [ [70, 120], [50, 80], [80, -85], [135, -95] ]
    ];

    constructor(
        private cvLocalizationFactory: CVLocalizationService,
        private agGridHelperService: AgGridHelperService,
        public objectivesService: CxoneObjectivesService,
        public toastrManager: ToastrManager,
        private dialogSrvc: DialogService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal,
        private tagifyService: TagifyService,
        private metricSelectorService: MetricSelectorService
    ) {}

    async ngOnInit() {
        this.localization = await this.cvLocalizationFactory.GetSection("CXOne_Objectives");
        this.userList = await this.objectivesService.loadUsersList();
        await this.loadObjectives();

        this.groupTypes = await this.objectivesService.loadGroupTypes();
        this.standardOptions = await this.objectivesService.loadPalettes();

        this.setupAgGrid();
        this.updateNoRowsMessage();
        this.initLocalizedObjects();
        sendMessageCXOne({ hasNonSavedChanges: false });
    }

    /**
     * Populate the objects with the proper localized labels
     * */
    public initLocalizedObjects() {
        this.NormalizedEmailTimeIntervalList = [
            {value: 1, label:this.getLocalizationString("Days", "Days"), index: 0},
            {value: 2, label:this.getLocalizationString("Weeks", "Weeks"), index: 1},
            {value: 3, label:this.getLocalizationString("Months", "Months"), index: 2},
            {value: 4, label:this.getLocalizationString("Hours", "Hours"), index: 3},
        ];

        this.CountEmailTimeIntervalList = [
            {value: 1, label:this.getLocalizationString("Days", "Days"), index: 0},
            {value: 2, label:this.getLocalizationString("Weeks", "Weeks"), index: 1},
            {value: 3, label:this.getLocalizationString("Months", "Months"), index: 2},
        ];
    
        this.NotificationTypeList = [
            {label: this.getLocalizationString("Email", "Email"), value: "Email"},
            {label: this.getLocalizationString("System_Notification", "System Notification"), value: "System"} 
        ];

        this.normalizedMetricPlaceHolder = this.getLocalizationString("All_Groups", "All Groups");
    }

    /**
     * Pull the objectives from the backend and load them into their respective variables
     * */
    public async loadObjectives(){
        await this.objectivesService.loadObjectives().then(response => {
            this.assignmentData = response.assignmentData;
            this.metricAbrDict = response.metricAbrDict;
            this.profilesInLevel = response.profilesInLevel;
        });
    }

    /**
     * Applies search filter to the AG Grid.
     * */
    public applyFilter() {
        if (this.agGrid?.api) {
            this.curObjectiveCount = 0;
            this.agGrid?.api.onFilterChanged();

            if (this.agGrid?.api?.getDisplayedRowCount() === 0)
                this.agGrid?.api.showNoRowsOverlay();
            else
                this.agGrid?.api?.hideOverlay();
        }
    }

    /**
     * Sets up the AG Grid object.
     * */
    public setupAgGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            columnTypes: {
                simpleContextMenu: {
                    cellRendererSelector: (param) => {
                        if (param.data == null) {
                            return null;
                        }
                        else {
                            return { component: 'contextMenuCellRenderer' };
                        }
                    }
                },
            },
            columnDefs: [
                {
                    field: "MetricID",
                    colId: "MetricID",
                    headerName: this.getLocalizationString("Metrics", "Metrics"),
                    valueFormatter: (params) => {
                        if (params.value != null && this.metricAbrDict != null)
                            if (this.metricAbrDict[params.value] != null)
                                return this.metricAbrDict[params.value].MetricName;
                            else
                                return "";
                    },
                    rowGroup: true,
                    hide: true,
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: true,
                    width: 160,
                },
                {
                    field: "ObjectiveName", //name is not part of the object yet
                    colId: "ObjectiveName",
                    headerName: this.getLocalizationString("Objective_Name", "Objective Name"),
                    sort: "asc",
                    sortIndex: 1,
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    valueFormatter: (params) => {
                        if (params.value != null)
                            return params.value.toString();
                        else
                            return "";
                    },
                    width: 160,
                    resizable: true,
                    sortable: true,
                },
                {
                    field: "combinedObj.AssignedLevel",
                    colId: "combinedObj.AssignedLevel",
                    headerName: this.getLocalizationString("Group_Level", "Group Level"),
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: false,
                    width: 160,
                    valueFormatter: (params) => {
                        if (params.value != null) {
                            if (params.value == 6)
                                return this.getLocalizationString("All_Levels", "All Levels");

                            if (params.data.combinedObj.GroupingID > 0 || this.metricAbrDict[params.data.MetricID] == null)
                                return "";

                            if (this.metricAbrDict[params.data.MetricID].MetricObjectiveType == 0) { // Count so check for sub cards to append
                                // If grouping 0 and count type, then loop through and concat subcards
                                let str = this.groupTypes[params.data.combinedObj.AssignedType][params.value - 1].GroupTypeName;

                                for (let assignment of this.assignmentData) {
                                    if (assignment.combinedObj.GroupingID == params.data.combinedObj.ObjectiveID)
                                        str += ", " + this.groupTypes[params.data.combinedObj.AssignedType][assignment.combinedObj.AssignedLevel - 1].GroupTypeName;
                                }

                                return str;
                            }
                            else if (this.groupTypes[params.data.combinedObj.AssignedType][params.value - 1] != null) // Normalized, so no sub cards
                                return this.groupTypes[params.data.combinedObj.AssignedType][params.value - 1].GroupTypeName;
                        }

                        return "";
                    }
                },
                {
                    field: "assignments.emp",
                    headerName: this.getLocalizationString("Employee_Group", "Employee Group"),
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: false,
                    width:200,
                    flex: 1,
                    valueFormatter: (params) => {
                        let str = "";
                        if (params.value != null) {
                            if (params.value.length == 0)
                                str = this.getLocalizationString("All_Employee_Groups", "All Employee Groups");
                            else {
                                let groupNamesAlphabetical = params.value.map(o => o.GroupName).sort((a, b) => a > b ? 1 : -1);

                                for (let groupName of groupNamesAlphabetical) {
                                    if (str != "" && groupName != "")
                                        str += ", ";

                                    str += groupName;
                                }
                            }
                        }
                        return str;
                    }
                },
                {
                    field: "assignments.rec",
                    headerName: this.getLocalizationString("Contact_Group", "Contact Group"),
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: false,
                    width:200,
                    flex: 1,
                    valueFormatter: (params) => {
                        let str = "";
                        if (params.value != null) {
                            if (params.value.length == 0)
                                str = this.getLocalizationString("All_Contact_Groups", "All Contact Groups");
                            else {
                                let groupNamesAlphabetical = params.value.map(o => o.GroupName).sort((a, b) => a > b ? 1 : -1);

                                for (let groupName of groupNamesAlphabetical) {
                                    if (str != "" && groupName != "")
                                        str += ", ";

                                    str += groupName;
                                }
                            }
                        }
                        return str;
                    }
                },
                {
                    field: "MetricID",
                    colId: "MetricID",
                    headerName: this.getLocalizationString("Metric_Type", "Metric Type"),
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: true,
                    width: 104,
                    valueGetter: (params) => {
                        let value = params.getValue("MetricID");

                        if (value && this.metricAbrDict && this.metricAbrDict[value])
                            return this.metricAbrDict[value].MetricObjectiveType == 0
                                ? this.getLocalizationString("Count", "Count")
                                : this.getLocalizationString("Normalized", "Normalized");
                        else
                            return "";
                    },
                    cellStyle: (params) => {
                        if (params.node.aggData)
                            return "";

                        return {opacity: 0} as any;
                    },
                    aggFunc: "first"
                },
                {
                    colId: "contextMenu",
                    type: "simpleContextMenu",
                    width: 48,
                    suppressSizeToFit: true,
                    cellStyle: { "text-overflow": "unset" },
                    resizable: false,
                    sortable: false
                }
            ],
            onColumnResized: () => {
                this.agGrid?.api?.hidePopupMenu();
            },
            defaultColDef: {
                sortable: false,
                //cellClass: "d-flex align-items-center",
                menuTabs: [],
                resizable: false,
                icons: {
                    sortAscending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-up.svg#arrow-up"></use></svg></div>',
                    sortDescending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use></svg></div>',
                    filter: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/filter.svg#filter"></use></svg>',
                    menu: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/widget-menu.svg#widget-menu"></use></svg>',
                    columns: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/chart.svg#chart"></use></svg>',
                }
            },
            autoGroupColumnDef: {
                headerName: this.getLocalizationString("Metrics", "Metrics"),
                headerClass: "groupHeaderAlign",
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                    suppressCount: true,
                    innerRenderer: 'cxoneMetricNameCellRendererComponent'
                },
                sort: "asc",
                sortIndex: 0,
                valueFormatter: (params) => {
                    if (params.value != null && this.metricAbrDict != null)
                        if (this.metricAbrDict[params.value] != null)
                            return this.metricAbrDict[params.value].MetricName;
                        else
                            return "";
                },
                comparator: (valueA, valueB, nodeA, nodeB) => {
                    let midA = valueA ?? nodeA.data.MetricID;
                    let midB = valueB ?? nodeB.data.MetricID;

                    if (this.metricAbrDict != null) {
                        let nameA: string = "";
                        let nameB: string = "";

                        if (this.metricAbrDict[midA] != null)
                            nameA = this.metricAbrDict[midA].MetricName;
                        if (this.metricAbrDict[midB] != null)
                            nameB = this.metricAbrDict[midB].MetricName;

                        if (nameA > nameB)
                            return 1;
                        else if (nameA < nameB)
                            return -1;
                        else
                            return 0;
                    }
                    return 0;
                },
                suppressSizeToFit: true,
                lockPosition: true,
                resizable: true,
                sortable: true,
                width: 160,
                minWidth: 55, // Min width of 55, so resizing column to be very small will not allow the padding to overlap with neighbor columns
                cellStyle: {'display': 'block'}

            },
            onGridReady: params => {
                params.api.setGridOption('rowData', this.assignmentData);
            },
            onCellClicked: (event) => {
                //check to make sure the click did not happen on a group row, if failed this validation just return
                if (event.data == undefined) //Don't open if cell is a grouping
                    return;
                //validate that the column clicked is not the context menu either (no category and no context columns)
                if (event.colDef.colId == 'contextMenu') {
                    return;
                }
                this.editObjective(event.data);
            },
            onBodyScroll: params => {
                this.agGrid?.api?.hidePopupMenu();
            },
            components: {
                contextMenuCellRenderer: CxoneContextMenuCellRendererComponent,
                cxoneMetricNameCellRendererComponent: CxoneMetricNameCellRendererComponent,
                agColumnHeader: CxoneColumnHeaderRendererComponent
            },
            getRowId: ({ data: rowData }) => rowData.combinedObj.ObjectiveID,
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: (node) => {
                if (node.data.combinedObj.GroupingID > 0) // Hide subcards as they will be combined with their parent card
                    return false;

                let result = this.agGridHelperService.doesExternalFilterPassIncludeHidden(node, this.searchValue);
                if (result)
                    this.curObjectiveCount++;

                return result;
            },
            onFilterChanged: () => {
                this.agGrid?.api.redrawRows();
            },
            context: {
                DeactivateObjective: () => this.deactivateObjective(),
                getFilterText: () => this.searchValue,
                editClick: (objectiveDefinition) => this.editObjective(objectiveDefinition),
                deleteClick: (objectiveDefinition) => this.openObjectiveDeletePopup(objectiveDefinition)
            },
            getMainMenuItems: (params: any) => ["pinSubMenu", "autoSizeThis", "autoSizeAll", "resetColumns"],
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            suppressCellFocus: true,
            suppressMovableColumns: true,
            suppressAggFuncInHeader: true,
            rowClass: 'cx-one-ui',
            groupDefaultExpanded: 1,
            rowHeight: 36,
            headerHeight: 44,
            scrollbarWidth: 8
        });
    }

    /**
     * Resets the "no rows" message for the AG Grid.
     * */
    public updateNoRowsMessage() {
        this.gridOptions.overlayNoRowsTemplate = `<div>
                                                    <svg class="cxoneFavoriteState mb-2">
                                                        <use href="../App_Themes/CXone/icons/no-results.svg#no-results"></use>
                                                    </svg>
                                                    <p class="cxoneEmptyText">${this.getLocalizationString("No_Results", "No results found")}</p>
                                                </div>`;
    }

    /**
     * Returns localized string from the CXOne_Objectives localization section.
     * @param key Key for localized string to retrieve
     * @param defaultValue Value to return if error occurs
     * @param inserts Values to insert into the localized (or default) string; the first will replace {0}, the second will replace {1}, etc.
     */
    public getLocalizationString(key: string, defaultValue: string, ...inserts: string[]) {
        let baseString = this.cvLocalizationFactory.getCachedText("CXOne_Objectives", key, defaultValue);

        for (let i = 0; i < inserts.length; i++) {
            baseString = baseString.replace(`{${i}}`, inserts[i]);
        }

        return baseString;
    }

    /**
     * Opens the delete objective popup.
     * @param objective Objective to potentially delete
     */
    public openObjectiveDeletePopup(objective: ObjectiveAssignmentDataObj) {
        this.deleteTarget = objective;
        this.objectivesService.popoverObj.open();
    }

    /**
     * Deactivates the objective stored as deleteTarget, along with all of its sub objectives.
     * */
    public async deactivateObjective() {
        if (!this.deleteTarget?.combinedObj || this.deleteTarget.combinedObj.ObjectiveID == 0)
            return;

        // Logic to find the selected objective and any sub cards
        let objectiveIds: number[] = [];
        for (let assignment of this.assignmentData) {
            if (assignment.combinedObj.ObjectiveID == this.deleteTarget.combinedObj.ObjectiveID ||
                (assignment.combinedObj.GroupingID > 0 && assignment.combinedObj.GroupingID == this.deleteTarget.combinedObj.ObjectiveID)) {
                objectiveIds.push(assignment.combinedObj.ObjectiveID);
            }
        }

        let objectiveIdString = "";
        if (objectiveIds.length > 0) {
            for (let objectiveId of objectiveIds) {
                if (objectiveIdString == "")
                    objectiveIdString = objectiveId.toString();
                else
                    objectiveIdString += ", " + objectiveId.toString();
            }
        }

        await this.objectivesService.deactivateObjective(objectiveIdString);

        this.assignmentData = this.assignmentData.filter(item => {
            return (item.combinedObj.ObjectiveID != this.deleteTarget.combinedObj.ObjectiveID && item.combinedObj.GroupingID != this.deleteTarget.combinedObj.ObjectiveID);
        });

        this.agGrid?.api.setGridOption('rowData', this.assignmentData);
        this.applyFilter();
        this.toastrManager.showToaster("success", this.getLocalizationString("Objective_Deleted_Successful", "Objective deleted successfully."));

        this.deleteTarget = null;
    }

    /**
     * Opens the objective for editing.
     * @param objective Objective to edit
     */
    public async editObjective(objective: ObjectiveAssignmentDataObj) {
        this.isLoading = true;

        if (this.metricDefinitionsData == null)
            this.metricDefinitionsData = await this.objectivesService.getMetricDefinitions();

        if (objective.combinedObj.AlertsList == null || objective.assignments.attr == null || objective.combinedObj.ObjectiveDetails == null) {
            let objectiveDetailsObj: ObjectiveAssignmentDataObj = await this.objectivesService.loadObjectiveParts(objective.combinedObj.ObjectiveID, this.metricAbrDict[objective.MetricID].MetricObjectiveType, this.metricAbrDict[objective.MetricID].NumericType);
            objective.assignments.attr = cloneDeep(objectiveDetailsObj.assignments.attr);
            objective.combinedObj.ObjectiveDetails = cloneDeep(objectiveDetailsObj.combinedObj.ObjectiveDetails);
            objective.combinedObj.ObjectivePaletteID = objectiveDetailsObj.combinedObj.ObjectivePaletteID;
            objective.combinedObj.AlertsList = cloneDeep(objectiveDetailsObj.combinedObj.AlertsList);
        }

        this.selectedObjectiveList = [];
        this.selectedObjectiveList.push(cloneDeep(objective));

        for (let assignment of this.assignmentData) {
             // Add sub objectives to the list
            if (assignment.combinedObj.GroupingID === objective.combinedObj.ObjectiveID) {          
                if (assignment.combinedObj.AlertsList === null && assignment.combinedObj.ObjectiveDetails === null && assignment.assignments.attr === null) {
                    let subObjectiveDetailsObj: ObjectiveAssignmentDataObj = await this.objectivesService.loadObjectiveParts(assignment.combinedObj.ObjectiveID, this.metricAbrDict[objective.MetricID].MetricObjectiveType,this.metricAbrDict[objective.MetricID].NumericType);
                    assignment.combinedObj.AlertsList = cloneDeep(subObjectiveDetailsObj.combinedObj.AlertsList);
                    assignment.combinedObj.ObjectiveDetails = cloneDeep(subObjectiveDetailsObj.combinedObj.ObjectiveDetails);
                    assignment.assignments.attr = cloneDeep(subObjectiveDetailsObj.assignments.attr);
                }
                this.selectedObjectiveList.push(assignment);
            }
        }

        this.selectedObjective = this.selectedObjectiveList[0]; // Shallow copy the core card
        let metricDef = this.metricDefinitionsData.find((item) => item.MetricID == this.selectedObjective.MetricID);
        this.selectedObjective.assignments.recLevelMin = metricDef.RecLevelMin;
        this.selectedObjective.assignments.empLevelMin = metricDef.EmpLevelMin;
        this.originalEditObjectiveCopy = cloneDeep(this.selectedObjectiveList);

        // Get the proper values for Group Level and Select Group fields
        this.selectedGroupLevel = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].find(item => item.GroupLevel == this.selectedObjective.assignments.coreAssignAtLevel);
        if (this.selectedObjective.assignments.coreAssignAtType == 'emp') {
            if (this.selectedObjective.assignments.coreAssignAtLevel < this.selectedObjective.assignments.empLevelMin) {
                this.selectedGroupLevel = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].find(item => item.GroupLevel == this.selectedObjective.assignments.empLevelMin);
                this.levelSelected();
            }
        } else {
            if (this.selectedObjective.assignments.coreAssignAtLevel < this.selectedObjective.assignments.recLevelMin) {
                this.selectedGroupLevel = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].find(item => item.GroupLevel == this.selectedObjective.assignments.recLevelMin);
                this.levelSelected();
            }   
        }

            
        if (this.currentMetricType == 0) {
            if (this.selectedObjective.assignments[this.selectedObjective.assignments.coreAssignAtType][0]?.GroupLevel == this.groupTypes[this.selectedObjective.assignments.coreAssignAtType].length) {
                this.selectGroupValue = "All"
            }
            else {
                this.selectGroupValue = "Specific";
            }

            this.previousSelectGroup = this.selectGroupValue;
        }
        if (this.selectedObjective && this.selectedObjective?.combinedObj && this.selectedObjective?.combinedObj?.ObjectivePaletteID) {
            this.selectedPalette = this.standardOptions?.find(option => option?.ObjectivePaletteID === this.selectedObjective?.combinedObj?.ObjectivePaletteID);
        } else {
            this.selectedPalette = null;
        }

        this.initNotificationList = this.setUpNotificationTableData();

        this.selectedObjective.combinedObj.StartDate = new Date(this.selectedObjective.combinedObj.StartDate + "Z"); // specify UTC time
        this.levelDropdown = this.levelSelectOptions;
        this.isLoading = false;
        this.editPhase = 1;
    }

    /**
     * Returns to the landing view.
     * */
    public returnToLanding() {
        this.selectedObjectiveList = [];
        this.selectedObjective = null;
        this.editPhase = 0;
        this.selectGroupValue = "All";
        this.previousSelectGroup = this.selectGroupValue;
        this.selectedGroupLevel = null;
        this.objectiveNameError = 0;
        this.isNewObjective = false;

        this.selectedPalette = null;
        this.inputDisplays = [[], [], []];
        this.preInputDisplays = [[], [], []];
        this.unsavedInputs = [];
        this.secondSaveDisabled = true;
        this.secondViewSaveClicked = false;
        this.showBackValidationMessage = false;
        this.enableWeekAutoFill = false;
        this.enableMonthAutoFill = false;
        this.showCancelValidationMessage = false;
        this.filterLevelSelection = [];
        this.filterNotificationTypeSelection = [];
        this.notificationGridOptions = null;
        sendMessageCXOne({ hasNonSavedChanges: false });
        this.clearNotificationLists();
    }

    public returnToLandingChangeDetection() {

        if(this.selectedObjective.combinedObj.ObjectiveID == 0){
            //create
            if(
                this.selectedObjective.MetricID != 0 ||
                this.selectedObjective.ObjectiveName != ""
            ){
                this.showValidationModal(
                    this.getLocalizationString('Unsaved_Changes_Header', "Leave without saving?"), 
                    'user-warning',
                    "<div>" + this.getLocalizationString('Changes_Lost', "All changes will be lost") + "</div>" + "<div>" + this.getLocalizationString('Leave_Page_Message', "Are you sure you want to leave the page without saving?") + "</div>",
                    this.getLocalizationString('Leave', "Leave"),
                    true, 
                    '420px',
                    '184px',
                    () => {
                        this.returnToLanding();
                    },
                    () => {}, 
                    this.getLocalizationString('Stay', "Stay")
                );
            }
            else{
                this.returnToLanding();
            }
        }
        else{
            //edit
            if(this.isObjectiveChanged() || this.showCancelValidationMessage){
                this.showValidationModal(
                    this.getLocalizationString('Unsaved_Changes_Header', "Leave without saving?"), 
                    'user-warning',
                    "<div>" + this.getLocalizationString('Changes_Lost', "All changes will be lost") + "</div>" + "<div>" + this.getLocalizationString('Leave_Page_Message', "Are you sure you want to leave the page without saving?") + "</div>",
                    this.getLocalizationString('Leave', "Leave"),
                    true, 
                    '420px',
                    '184px',
                    () => {
                        this.returnToLanding();
                    },
                    () => {}, 
                    this.getLocalizationString('Stay', "Stay")
                );
            }
            else{
                this.returnToLanding();
            }
        }

        
    }

    /**
     * Prepares data and shifts view for the creation of a new objective by the user.
     * */
    public async openObjectiveCreation() {
        if (this.metricDefinitionsData == null)
            this.metricDefinitionsData = await this.objectivesService.getMetricDefinitions();
        this.isNewObjective = true;
        this.selectedObjectiveList = [];
        this.selectedObjectiveList.push(this.newObjectiveObject());
        this.selectedObjective = this.selectedObjectiveList[0];
        this.editPhase = 1;
    }

    /**
     * Sets objectiveNameError to the proper value depending on the current status of the selectedObjective.ObjectiveName field.
     * */
    public validateObjectiveName() {
        if (!this.selectedObjective.ObjectiveName){ // Name required
            this.objectiveNameError = 1;
        }
        else if (this.selectedObjective.ObjectiveName.trim().replace(/\s+/g, ' ').length > 30){ // Name can't be longer than 30 characters
            this.objectiveNameError = 2;
        }
        else if (this.selectedObjective.ObjectiveName.includes('<') || this.selectedObjective.ObjectiveName.includes('>')){ // Name can't use < or > characters
            this.objectiveNameError = 3;
        }
        else if (this.assignmentData.find(o => o.ObjectiveName.toLowerCase() == this.selectedObjective.ObjectiveName.trim().replace(/\s+/g, ' ').toLowerCase() && o.combinedObj.ObjectiveID != this.selectedObjective.combinedObj.ObjectiveID && (this.selectedObjective.combinedObj.ObjectiveID != 0 ? o.combinedObj.GroupingID != this.selectedObjective.combinedObj.ObjectiveID : true))){ // Name must be unique
            this.objectiveNameError = 4;
        }
        else
            this.objectiveNameError = 0;
    }

    public openSelectorModal(metricToSend) {
        let metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, metricToSend);
        metricSelector.result.then(result => {
            if (result) {
                let newMetricId = result.length > 0 ? parseInt(result[0].MetricID) : 0;
                let newMetricType = this.metricAbrDict[newMetricId]?.MetricObjectiveType ?? -1;
                // Reset Assign Objective and Assign Groups sections when switching between metric types
                if (this.currentMetricType != newMetricType) {
                    this.selectedObjective.assignments.coreAssignAtLevel = newMetricType != 1 ? 0 : 6;
                    this.selectedObjective.assignments.coreAssignAtType = "emp";
                    this.selectedObjective.combinedObj.AssignedLevel = newMetricType != 1 ? 0 : 6;
                    this.selectedObjective.combinedObj.AssignedType = "emp";
                    this.selectedGroupLevel = null;
                    this.selectGroupValue = "All";
                    this.previousSelectGroup = this.selectGroupValue;
                    this.resetCards();
                }
                this.clearAllRanges();
                this.clearAllAlerts();
                this.clearNotificationLists();
                this.selectedObjective.MetricID = newMetricId;

                let metricDef = this.metricDefinitionsData.find((item) => item.MetricID == newMetricId);
                this.selectedObjective.assignments.recLevelMin = metricDef.RecLevelMin;
                this.selectedObjective.assignments.empLevelMin = metricDef.EmpLevelMin;
                this.defaultAssignAllLevels("emp");
                this.defaultAssignAllLevels("rec");
                this.recalculateGroups();

                //Reset Count Metrics
                if (this.currentMetricType == 0) {
                    if (this.currentObjectiveEmpGroupIsTopLevel && this.currentObjectiveRecGroupIsTopLevel) {
                        this.selectedObjective.assignments.coreAssignAtType = "emp";
                    }
                    else if (this.currentObjectiveEmpGroupIsTopLevel) {
                        this.selectedObjective.assignments.coreAssignAtType = "rec";
                    }
                    else if (this.currentObjectiveRecGroupIsTopLevel) {
                        this.selectedObjective.assignments.coreAssignAtType = "emp";
                    }
                    this.selectedObjective.combinedObj.AssignedType = this.selectedObjective.assignments.coreAssignAtType;
                    this.selectedGroupLevel = null;
                    this.selectedObjective.assignments.coreAssignAtLevel = 0;
                    this.selectedObjective.combinedObj.AssignedLevel = 0;
                    this.selectedObjective.assignments.empAssignAll = false;
                    this.selectedObjective.assignments.recAssignAll = false;
                    this.levelDropdown = this.levelSelectOptions;
                }
            }
        });
    }

    /**
     * Opens the metric selector.
     * */
    public openMetricSelector() {

        let metricToSend = null;

        if(this.selectedObjective.MetricID > 0){
            let currentMetric = this.metricAbrDict[this.selectedObjective.MetricID];

            metricToSend = {
            mID: currentMetric.MetricID,
            mAbr: currentMetric.MetricName,
            mName: currentMetric.MetricName,
            mDir: currentMetric.Direction,
            DisplayName: currentMetric.MetricName,
            mCT: currentMetric.MetricObjectiveType,
        }
        }
        if(this.currentMetricType != 1){
            if(this.selectedObjective.assignments.emp.length > 0 || this.selectedObjective.assignments.rec.length > 0 || this.selectedGroupLevel != null){
                this.showValidationModal(
                    this.getLocalizationString('Change_Metric_Header', "Change Metric"),
                    'user-warning',
                    this.getLocalizationString('Change_Metric_Message', "Changing the metric will remove set values"),
                    this.getLocalizationString('Continue', "Continue"),
                    true,
                    '420px',
                    '184px',
                    () => this.openSelectorModal(metricToSend),
                    () => { },
                    this.getLocalizationString('Cancel', "Cancel")
                );
            }
            else {
                this.openSelectorModal(metricToSend);
            }
        }
        else {
            //here I check for any ranges
            let rangesResult = false;
            for(let i = 0; i < this.selectedObjectiveList.length; i++){
                if(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails.length > 0){
                    rangesResult = true;
                }
            }

            if (rangesResult) {
                this.showValidationModal(
                    this.getLocalizationString('Change_Metric_Header', "Change Metric"),
                    'user-warning',
                    this.getLocalizationString('Change_Metric_Message', "Changing the metric will remove set values"),
                    this.getLocalizationString('Continue', "Continue"),
                    true,
                    '420px',
                    '184px',
                    () => this.openSelectorModal(metricToSend),
                    () => { },
                    this.getLocalizationString('Cancel', "Cancel")
                );
            }
            else {
                this.openSelectorModal(metricToSend);
            }
        }
    }

    /**
     * Returns a new, blank objective object.
     * */
    public newObjectiveObject() {
        return {
            combinedObj: {
                ObjectiveID: 0,
                CompanyID: 0,
                GroupingID: 0,
                StartDate: new Date(),
                EndDate: null,
                ObjectivePaletteID: 0,
                AssignedLevel: 0,
                AssignedType: "emp",
                ObjectiveDetails: [],
                AlertsList: [[], [], []]
            } as ObjectiveDetailsDataObj,
            assignments: {
                empAssignAll: false,
                recAssignAll: false,
                emp: [],
                rec: [],
                attr: [],
                coreAssignAtType: "emp",
                coreAssignAtLevel: 0
            } as ObjectiveAssignAtDataObj,
            MetricID: 0,
            ObjectiveName: ""
        } as ObjectiveAssignmentDataObj;
    }

    /**

    /**
     * Triggered after the Level field is changed; ensures that both level properties of the selectedObjective are the same
     * */
    public levelSelected() {
        this.selectedObjective.assignments.coreAssignAtLevel = this.selectedGroupLevel.GroupLevel;
        this.selectedObjective.combinedObj.AssignedLevel = this.selectedGroupLevel.GroupLevel;
        this.selectedObjective.combinedObj.AssignedType = this.selectedGroupLevel.BaseGroupType == 0 ? "emp" : "rec";
        this.selectedObjective.assignments.coreAssignAtType = this.selectedObjective.combinedObj.AssignedType;
        this.clearNotificationLists();

        // If the selected level is the highest, then it cannot have "All" for the Select Groups field
        if (this.selectedGroupLevel.GroupLevel == this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].length)
            this.selectGroupValue = "Specific";
            this.previousSelectGroup = this.selectGroupValue;

        if(this.selectedObjective.assignments.coreAssignAtType == "emp"){
            this.selectedObjective.assignments.recAssignAll = true;
            this.selectedObjective.assignments.empAssignAll = false;
        }
        else{
            this.selectedObjective.assignments.empAssignAll = true;
            this.selectedObjective.assignments.recAssignAll = false;
        }

        this.clearAllRanges();
        this.clearAllAlerts();
        this.resetCards();
    }

    /**
     *  This function fires when the level dropdown is opened. I need to save the previous selection before the user selects a new selection from the dropdown
     * */
    public saveLevelDropdownSelection(){
        this.previousLevelSelection = this.selectedGroupLevel;
    }

    /**
     * Function to show the Changing Level Validation message. If the user clicks Cancel it keeps the data. If the user clicks Yes it changes the level and clears data
     * */
    public newLevelDropdownSelection(){
        //if statement to check if the assign groups section is empty. if empty don't show the validation message cause their is no data for the user to lose. 
        if(this.currentAssignedEmpGroups.length > 0 || this.currentAssignedRecGroups.length > 0){
            this.newLevelSelection = this.selectedGroupLevel;

            let index = 0;
            for(let i = 0; i < this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].length; i++){
                if(this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'][i].GroupLevel == this.previousLevelSelection.GroupLevel){
                    index = i
                }
            }

            this.selectedGroupLevel = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'][index];
            this.cdr.detectChanges();

            this.showValidationModal(
                this.getLocalizationString('Changing_Level_Header', "Changing Level"), 
                'user-warning',
                this.getLocalizationString('Changing_Level_Message', "Changing this setting will remove all previous assignments, Do you want to continue?"),
                this.getLocalizationString('Yes', "Yes"),
                true, 
                '420px',
                '184px',
                () => {
                    this.selectedGroupLevel = this.newLevelSelection;
                    this.levelSelected();
                },
                () => {
                    this.displayLevelDropdown = false;
                    this.cdr.detectChanges();
                    this.displayLevelDropdown = true;
                    this.cdr.detectChanges();
                }, 
                this.getLocalizationString('Cancel', "Cancel")
            );
        }
        else{
            this.levelSelected();
        }
    }

    /**
     * Resets all Assign Group related data.
     * */
    public resetCards() {
        this.selectedObjective.assignments.emp = [];
        this.selectedObjective.assignments.rec = [];

        if (this.selectedObjectiveList.length > 1)
            this.selectedObjectiveList = [this.selectedObjectiveList[0]];
        this.defaultAssignAllLevels("emp");
        this.defaultAssignAllLevels("rec");
    }

    /**
     * Function to show the Select Groups validation message. If the user clicks continue remove the user data and change the radio button
     * If the user clicks the Cancel button then keep the old selection and don't remove data
     * */
    public selectGroupsValidation() {
        //if statement to check for empty assign groups. if it is empty don't need to show the validation message
        if(this.selectedObjective.assignments.emp.length > 0 || this.selectedObjective.assignments.rec.length > 0){
            //get the old selection
            let newSelectGroup = this.selectGroupValue;
            let groupTypeLength = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].length;

            this.selectGroupValue = this.previousSelectGroup;

            if(JSON.stringify(this.selectedGroupLevel) == JSON.stringify(this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'][groupTypeLength - 1])){
                //this is the case where the second radio button is disabled so nothing should happen
            }
            else if(JSON.stringify(newSelectGroup) == JSON.stringify(this.previousSelectGroup)){
                //this is the case where the user clicked the same radio button that they already had selected. so do nothing
            }
            else{
                this.showValidationModal(
                    this.getLocalizationString('Change_SelectGroup_Header', "Change Select Group", this.selectedGroupLevel.GroupTypeName), 
                    'user-warning',
                    this.getLocalizationString('Change_SelectGroup_Message', "Changing the select group will remove set values", this.selectedGroupLevel.GroupTypeName),
                    this.getLocalizationString('Continue', "Continue"),
                    true, 
                    '420px',
                    '184px',
                    () => {
                        this.selectGroupValue = newSelectGroup;
                        this.previousSelectGroup = newSelectGroup;
                        this.resetCards();
                    },
                    () => {
                        //I have to do some ngIf magic to make the radio buttons update. So here I'm just flashing the radio button component
                        this.selectGroupsRadioButton = false;
                        this.cdr.detectChanges();
                        this.selectGroupsRadioButton = true;
                        this.cdr.detectChanges();
                    }, 
                    this.getLocalizationString('Cancel', "Cancel")
                );
            }
        }
        else{
            this.resetCards();
            this.previousSelectGroup = this.selectGroupValue;
        }
        
    }

    /**
     * Returns true if the "Assign Groups" section card of the specified group level should be displayed, false if otherwise.
     * The conditions for the cards became complex, so this was the most efficient way to handle it.
     * @param groupLevel Group Level corresponding to card
     */
    public displayAssignGroupsCard(groupLevel: number) {
        if (this.isPrimaryCard(groupLevel)) // Is the current primary card
            // Always display
            return true;
        else if (groupLevel < this.selectedObjective.assignments.coreAssignAtLevel) { // Card's level is less than objective's base level
            // Display only if both Emp and Rec groups have been selected and it's a Count Metric
            if ((this.selectedObjective.assignments.emp.length > 0 || this.selectedObjective.assignments.empAssignAll) && (this.selectedObjective.assignments.rec.length > 0 || this.selectedObjective.assignments.recAssignAll) && this.currentMetricType == 0)
                return true;
        }

        return false;
    }

    /**
     * Returns true if the card corresponding to the inputted group level is the primary card at this time.
     * @param groupLevel Group Level corresponding to card
     */
    public isPrimaryCard(groupLevel: number) {
        if (this.selectedObjective.assignments.coreAssignAtLevel == 0 || this.selectedObjective.assignments.coreAssignAtLevel == 6) // No coreAssignAtLevel yet or All Groups, true if it's the highest card
            return groupLevel == this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'][this.groupTypes[this.selectedObjective.assignments.coreAssignAtType ?? 'emp'].length - 1].GroupLevel;
        else // coreAssignAtLevel has a value 1-5, true if it's the same as coreAssignAtLevel
            return groupLevel == this.selectedObjective.assignments.coreAssignAtLevel;
    }

    /**
     * Returns true if there is, for the objective currently being edited, a sub-objective that has a coreAssignAtLevel value equal to the inputted group level number, false if otherwise.
     * @param level Number representing a group level to search the sub-objectives for
     */
    public subObjectiveOfLevelExists(level: number) {
        if (this.selectedObjectiveList.length < 2)
            return false;

        return !!this.selectedObjectiveList.find(o => o.assignments.coreAssignAtLevel == level);
    }

    /**
     * Returns true if the edit flow is in a state where the Assign/Edit buttons can be enabled.
     * */
    public readyToAssignGroups() {
        return this.currentMetricType == 1 || (this.currentMetricType == 0 && this.selectedObjective.assignments.coreAssignAtType && this.selectedGroupLevel && this.selectGroupValue);
    }

    /**
     * Empties the list of performance Notifications.
     * */
    public clearNotificationLists() {
        this.curNotificationList = [];
        this.initNotificationList = [];
    }

    /**
     * Fires the validation message for assigning a group for normalized metrics with existing notifications.
     * If the user clicks Continue it will open the assign modal.
     * */
    public assignGroupValidation(type: GroupType) {
        let notificationsPresent = this.initNotificationList.length > 0;

        if(this.currentMetricType == 1 && notificationsPresent){
            this.showValidationModal(
                this.getLocalizationString('Change_Group_Header', "Change Group Type?"), 
                'user-warning',
                this.getLocalizationString('Change_Group_Message', "Changing group type resets values and remove notifications."),
                this.getLocalizationString('Continue', "Continue"),
                true, 
                '420px',
                '184px',
                () => this.openAssignModal(type),
                () => {
                }, 
                this.getLocalizationString('Cancel', "Cancel")
            );

        }
        else{
            this.openAssignModal(type);
        }
        this.isObjectiveChanged();
    }

    /**
     * Sets the list of groups to empty all groups that are included
     * @param type "emp" for Employee groups, "rec" for Contact groups
     */
    public defaultAssignAllLevels(type: string) {
        if (type == "emp") {
            if (this.selectedObjective.assignments.empLevelMin == 1 || this.currentMetricType == 0) {
                this.selectedObjective.assignments[type] = [];
                return;
            }
            this.selectedObjective.assignments[type] = [];
            for (let i = this.selectedObjective.assignments.empLevelMin; i <= this.groupTypes.emp.length; i++) {
                this.selectedObjective.assignments[type].push({
                    GroupID: 0,
                    CompanyID: 0,
                    GroupName: this.getLocalizationString("All", "All") + " " + this.groupTypes.emp[i - 1].GroupTypeName + " " + this.getLocalizationString("Groups", "Groups"),
                    Active: false,
                    ParentGroupID: 0,
                    Group1ID: 0,
                    Group2ID: 0,
                    Group3ID: 0,
                    Group4ID: 0,
                    Group5ID: 0,
                    GroupLevel: i,
                    BaseGroupType: 0,
                    Email: '',
                    ReceiveAlerts: false,
                    FirstName: '',
                    LastName: '',
                    ACDID: 0,
                    ACDSource: ''
                });
            }
        } else {
            if (this.selectedObjective.assignments.recLevelMin == 1 || this.currentMetricType == 0) {
                this.selectedObjective.assignments[type] = [];
                return;
            }
            this.selectedObjective.assignments[type] = [];
            for (let i = this.selectedObjective.assignments.recLevelMin; i <= this.groupTypes.rec.length; i++) {
                this.selectedObjective.assignments[type].push({
                    GroupID: 0,
                    CompanyID: 0,
                    GroupName: this.getLocalizationString("All", "All") + " " + this.groupTypes.rec[i - 1].GroupTypeName + " " + this.getLocalizationString("Groups", "Groups"),
                    Active: false,
                    ParentGroupID: 0,
                    Group1ID: 0,
                    Group2ID: 0,
                    Group3ID: 0,
                    Group4ID: 0,
                    Group5ID: 0,
                    GroupLevel: i,
                    BaseGroupType: 1,
                    Email: '',
                    ReceiveAlerts: false,
                    FirstName: '',
                    LastName: '',
                    ACDID: 0,
                    ACDSource: ''
                });
            }
        }
    }

    /**
     * Opens the assign tool modal for the specified group type.
     * @param type "emp" for Employee groups, "rec" for Contact groups
     */
    public openAssignModal(type: GroupType) {
        let assigned: CvCxEntities = {
            emp: [],
            rec: [],
            agentAttribute: [],
            login: []
        };

        assigned[type] = this.selectedObjective.assignments[type].filter(value => value.GroupID != 0);

        let options: CvCxAssignToolOptions = {
            modalTitle: type == "emp" ? this.getLocalizationString("Assign_Employee_Group", "Assign Employee Group") : this.getLocalizationString("Assign_Contact_Group", "Assign Contact Group"),
            modalSaveLabel: this.getLocalizationString("Assign", "Assign"),
            modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
            useBulkAdd: false,
            singleAdd: false,
            singleLevel: true,
            singleType: true,
            showTypeValues: { emp: type == "emp", rec: type == "rec", agent_att: false, logins: false },
            assignedEntities: assigned
        };

        // Set the available levels within the assign tool
        // For normalized metrics or assigning groups of the type currently not selected under the Group Type field: all levels are allowed
        // For count metrics when assigning groups of the type currently selected under the Group Type field: only higher levels are allowed if the Select Groups field
        // is set to "All", and only the current level is allowed if the Select Groups field is set to "Specific"
        if (this.currentMetricType == 0) { // Count metric
            if (this.selectGroupValue == "All") { // Select Groups field has "All" selected
                if (this.selectedObjective.assignments.coreAssignAtType == "emp")
                    options.singleEmpLevel = this.groupTypes["emp"].find(item => item.GroupTypeName == "Company").GroupLevel;
                else
                    options.singleRecLevel = this.groupTypes["rec"].find(item => item.GroupTypeName == "Company").GroupLevel;
            }
            else { // Select Groups field has "Specific" selected
                options.singleEmpLevel = this.selectedObjective.assignments.coreAssignAtType == "emp" ? this.selectedObjective.assignments.coreAssignAtLevel : undefined;
                options.singleRecLevel = this.selectedObjective.assignments.coreAssignAtType == "rec" ? this.selectedObjective.assignments.coreAssignAtLevel : undefined;
            }

            if (this.selectedObjective.assignments.coreAssignAtType != "emp") { //filter options to match Dashboards
                options.maxRecLevel = this.groupTypes["rec"].find(item => item.GroupTypeName == "Company").GroupLevel - (this.selectGroupValue == "All" ? 0 : 1);
                options.minRecLevel = this.selectedObjective.assignments.recLevelMin == 1 ? this.selectedObjective.assignments.recLevelMin + 1 : this.selectedObjective.assignments.recLevelMin;
            }
            else {
                options.maxEmpLevel = this.groupTypes["emp"].find(item => item.GroupTypeName == "Company").GroupLevel - (this.selectGroupValue == "All" ? 0 : 1);
                options.minEmpLevel = this.selectedObjective.assignments.empLevelMin;
            }
        }

        if(this.currentMetricType == 1) { // Normalized metric
            options.maxEmpLevel = this.groupTypes["emp"].find(item => item.GroupTypeName == "Company").GroupLevel - 1;
            options.maxRecLevel = this.groupTypes["rec"].find(item => item.GroupTypeName == "Company").GroupLevel - 1;
            options.minRecLevel = this.selectedObjective.assignments.recLevelMin == 1 ? this.selectedObjective.assignments.recLevelMin + 1 : this.selectedObjective.assignments.recLevelMin;
            options.minEmpLevel = this.selectedObjective.assignments.empLevelMin;
        }

        this.assignModal = this.dialogSrvc.open(CvCxoneAssignToolComponent, {
            width: "1198px",
            height: "665px",
            baseZIndex: 10000,
            data: {
                options: options
            },
            styleClass: 'cx-one-ui btn-bg-is-white'
        });

        // Fire another function once the Assign Modal is closed
        this.assignModal.onClose.pipe(first()).subscribe(this.assignToolClosed.bind(this, type));
    }

    /**
     * Handles the data returned from the assign tool when it is closed.
     * @param type "emp" for Employee groups, "rec" for Contact groups
     * @param dto Object returned from assign tool
     */
    public assignToolClosed(type: GroupType, dto: CvCxAssignToolDTO) {
        if (dto) {
            this.selectedObjective.assignments[type] = [...dto.selected[type], ...dto.assigned[type]];
            if(dto.selected[type].length > 0 || dto.assigned[type].length > 0)
                this.recalculateGroups();
            else {
                this.defaultAssignAllLevels(type);
                this.recalculateGroups();
            }
        }
    }

    /**
     * Refreshes certain values related to group assignments, like ensuring that empty normalized objectives have the right values and that subcards have the same assignments as the main.
     * */
    public recalculateGroups() {
        // Empty normalized objectives need certain values reset to defaults.
        if (this.currentMetricType == 1) {
            if (this.selectedObjective.assignments["emp"].filter(value => value.GroupID != 0).length > 0) {

                if(this.selectedObjective.assignments.coreAssignAtLevel != this.selectedObjective.assignments.emp[0].GroupLevel  || this.selectedObjective.combinedObj.AssignedType != "emp"){
                    //remove notification data
                    this.clearNotificationLists();
                }

                this.selectedObjective.assignments.coreAssignAtLevel = this.selectedObjective.assignments.emp[0].GroupLevel;
                this.selectedObjective.assignments.coreAssignAtType = "emp";
                this.selectedObjective.combinedObj.AssignedLevel = this.selectedObjective.assignments.emp[0].GroupLevel;
                this.selectedObjective.combinedObj.AssignedType = "emp";
            }
            else if (this.selectedObjective.assignments["rec"].filter(value => value.GroupID != 0).length > 0) {
                if(this.selectedObjective.assignments.coreAssignAtType != "rec"){
                    this.selectedObjective.assignments.recAssignAll = true;
                }

                if(this.selectedObjective.assignments.coreAssignAtLevel != this.selectedObjective.assignments.rec[0].GroupLevel || this.selectedObjective.combinedObj.AssignedType != "rec"){
                    //remove notification data
                    this.clearNotificationLists();
                }

                this.selectedObjective.assignments.coreAssignAtLevel = this.selectedObjective.assignments.rec[0].GroupLevel;
                this.selectedObjective.assignments.coreAssignAtType = "rec";
                this.selectedObjective.combinedObj.AssignedLevel = this.selectedObjective.assignments.rec[0].GroupLevel;
                this.selectedObjective.combinedObj.AssignedType = "rec";
            }
            else {

                if(this.selectedObjective.assignments.coreAssignAtLevel != 6){
                    //remove notification data
                    this.clearNotificationLists();
                }

                this.selectedObjective.assignments.coreAssignAtLevel = 6;
                this.selectedObjective.assignments.coreAssignAtType = "emp";
                this.selectedObjective.combinedObj.AssignedLevel = 6;
                this.selectedObjective.combinedObj.AssignedType = "emp";
            }
        }

        if(this.selectedObjective.assignments.coreAssignAtType == "emp"){
            if(this.selectedObjective.assignments.rec.length == 0){
                this.selectedObjective.assignments.recAssignAll = true;
            }
        }
        else{
            if(this.selectedObjective.assignments.emp.length == 0){
                this.selectedObjective.assignments.empAssignAll = true;
            }
        }

        if (this.selectedObjective.assignments["emp"].filter(value => value.GroupID != 0).length == 0)
            this.selectedObjective.assignments.empAssignAll = true;
        if (this.selectedObjective.assignments["rec"].filter(value => value.GroupID != 0).length == 0)
            this.selectedObjective.assignments.recAssignAll = true;

        // Update subcards
        for (let objective of this.selectedObjectiveList) {
            objective.assignments.emp = [...this.selectedObjective.assignments.emp];
            objective.assignments.empAssignAll = this.selectedObjective.assignments.empAssignAll;
            objective.assignments.rec = [...this.selectedObjective.assignments.rec];
            objective.assignments.recAssignAll = this.selectedObjective.assignments.recAssignAll;
        }

        this.isObjectiveChanged();
    }

    /**
     * Creates a new sub-objective for the specified group level.
     * @param groupLevel Group level that the new sub-objective will be assigned to
     */
    public addSubObjective(groupLevel: number) {
        let copyObjective = cloneDeep(this.selectedObjective);
        copyObjective.assignments.coreAssignAtLevel = groupLevel;
        copyObjective.combinedObj.AssignedLevel = groupLevel;

        //Initialize all new ranges values to null
        copyObjective.combinedObj.ObjectiveDetails.forEach(item => {
            item.dayMinValue = null;
            item.monthMinValue = null;
            item.weekMinValue = null;
        });

        //initialize the alerts list to empty
        for(let i = 0; i < copyObjective.combinedObj.AlertsList.length; i++){
            copyObjective.combinedObj.AlertsList[i] = [];
        }

        this.selectedObjectiveList.push(copyObjective);
        this.selectedObjectiveList.sort((n1, n2) => (n1.combinedObj.AssignedLevel > n2.combinedObj.AssignedLevel ? -1 : 1));
    }

    /**
     * Removes the subcard from the objective being edited with the specified level. Nothing happens if there is no subcard with that level or if it is the main card.
     * @param level Level of subcard to be deleted
     */
    public deleteSubObjective(level: number) {
        let index = this.selectedObjectiveList.findIndex(o => level == o.assignments.coreAssignAtLevel);

        if (index < 1 || index >= this.selectedObjectiveList.length)
            return;
        this.selectedObjectiveList.splice(index, 1);

        //clear notifications associated with the level being deleted
        this.initNotificationList = this.initNotificationList.filter(item => item.SendToLevel != level);
        this.isObjectiveChanged();
    }

    /**
     * Returns to the Edit/Create view in the flow.
     * */
    public returnToEditCreateView(): void {
        this.editPhase = 1;

        this.selectedPalette = this.selectedObjective?.combinedObj ? this.standardOptions.find(option => option.ObjectivePaletteID === this.selectedObjective.combinedObj.ObjectivePaletteID) : null;
        this.inputDisplays = [[], [], []];
        this.preInputDisplays = [[], [], []];
        this.unsavedInputs = [];
        this.secondSaveDisabled = true;
        this.showBackValidationMessage = false;
        this.tabActiveArray = [];
        this.invalidObjectiveNames = [];
        this.tabIndex = 0;
        this.enableWeekAutoFill = false;
        this.enableMonthAutoFill = false;
        this.filterLevelSelection = [];
        this.filterNotificationTypeSelection = [];
        this.notificationGridOptions = null;
        this.curNotificationList = [...this.initNotificationList];

    }

    /**
     * Compares the initial notification list with the current one to detect changes
     * */
    public checkPerformanceNotificationChanges(): boolean {
        return JSON.stringify(this.initNotificationList) != JSON.stringify(this.curNotificationList);
    }
    
    /**
     * Function to show the Back button validation message. click Leave to remove data and change views
     * Click Stay to not lose any data and stay on the same view. 
     * */
    public backChangeDetection(){
        if((this.checkForAnyInputs() || this.checkPerformanceNotificationChanges()) && this.showBackValidationMessage){

            this.showValidationModal(
                this.getLocalizationString('Unsaved_Changes_Header', "Leave without saving?"), 
                'user-warning',
                "<div>" + this.getLocalizationString('Changes_Lost', "All changes will be lost") + "</div>" + "<div>" + this.getLocalizationString('Back_Message', "Are you sure you want to go back without saving?") + "</div>",
                this.getLocalizationString('Back', "Back"),
                true, 
                '420px',
                '184px',
                () => this.returnToEditCreateView(),
                () => {}, 
                this.getLocalizationString('Stay', "Stay")
            );

        }
        else{
            this.returnToEditCreateView();
        }
    }

    /**
     * Moves to the Performance Range view in the flow.
     * */
    public openPerformanceRangeView() {
        this.editPhase = 2;

        if (!this.selectedPalette)
            this.selectedPalette = this.standardOptions[0];

        if(this.selectedObjectiveList[0].combinedObj.ObjectiveDetails.length == 0){
            this.createTabChange = true;
        }

        for(let i = 0; i < this.selectedObjectiveList.length; i++){
            this.tabActiveArray[i] = false;
        }
        this.tabActiveArray[this.tabIndex] = true;

        this.curNotificationList = [...this.initNotificationList];
        this.omnibarSearchBarPlaceHolder = this.getLocalizationString("Search_Placeholder","Search...")

        //notification table set up
        this.setFilterOptions();
        this.notificationGridOptions = this.getNotificationGridOptions();
        this.notificationSelectedLabel = "0 " + this.getLocalizationString("Selected", "Selected");
        this.onNotificationsSearchChange("");
    }

    /**
     * Function for when tabs are changed in the performance range page
     */
    public tabChanged(param: any): void{

        //if selectedObjectiveList has data in it then do the edit functionality and vice versa
        if(this.createTabChange){
            this.rangeInputPlaceholder();
            this.emptyInputLoad();
            
            this.inputDisplays = [[], [], []];
        }
        else{
            //call the checkForPartiallyFilledOutColumns so if their are partially filled out ones then I can show the validation message. 
            //if everything is filled out right let the user change tabs without validation
            if(this.checkForPartiallyFilledOutColumns()){
                this.showValidationModal(
                    this.getLocalizationString('Switch_Group_Header', "Switch Group?"), 
                    'user-warning',
                    this.getLocalizationString('Switch_Group_Message', "Range values for objectives in {0} still need to be set.", this.groupTypes[this.selectedObjectiveList[this.tabIndex].assignments.coreAssignAtType][this.selectedObjectiveList[this.tabIndex].assignments.coreAssignAtLevel - 1]?.GroupTypeName),
                    this.getLocalizationString('Switch_Group', "Switch Group"),
                    true, 
                    '420px',
                    '184px',
                    () => {
                        //here I'm setting the index for what selectedObjectiveList we are working on
                        //note to users. This also fires when the page is loaded initially. it fires right after openPerformanceRangeView
                        for(let i = 0; i < this.selectedObjectiveList.length; i++){
                            if(this.selectedObjectiveList[i].combinedObj.AssignedLevel == param){
                                this.tabIndex = i;
                            }
                        }

                        this.tabChangeLoad();
                    },
                    () => {
                        for(let i = 0; i < this.selectedObjectiveList.length; i++){
                            this.tabActiveArray[i] = false;
                        }

                        this.secondSaveDisabled = true;

                        this.tabActiveArray[this.tabIndex] = true;
                        this.editPhase = 1;
                        this.cdr.detectChanges();
                        this.editPhase = 2;
                        this.cdr.detectChanges();
                    }, 
                    this.getLocalizationString('Set', "Set")
                );
            }
            else{
                //here I'm setting the index for what selectedObjectiveList we are working on
                //note to users. This also fires when the page is loaded initially. it fires right after openPerformanceRangeView
                for(let i = 0; i < this.selectedObjectiveList.length; i++){
                    if(this.selectedObjectiveList[i].combinedObj.AssignedLevel == param){
                        this.tabIndex = i;
                    }
                }

                this.tabChangeLoad();
            }
        }

        this.createTabChange = false;
        //without the detectChanges it gives console errors about how expressions changed
        this.cdr.detectChanges();

        this.checkIfAutofilled();
    }

    /**
     * Function for clearing the input section when the ranges are changed
     */
    public rangesChanged() {
        //when the user changes ranges need to clear everything
        this.unsavedInputs = [];
        this.emptyInputLoad();

        this.inputDisplays = [[], [], []];
        this.displayRedBorder = [[], [], []];
    }

    /**
     * Function for deciding what placeholder to display for the input section
     */
    public rangeInputPlaceholder() {
        switch (this.metricAbrDict[this.selectedObjective.MetricID].NumericType) {
            case 0: // Currency
                return "--";
            case 1: // Number
                return "--";
            case 2: // Percent
                return "%";
            case 3: // Time
                switch (this.metricAbrDict[this.selectedObjective.MetricID].TimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return "--";
                    case 4: // Time
                        return "hh:mm:ss";
                    default:
                        return "--";
                }
            default:
                return "--";
        }
    }

    /**
     * Loads empty displays for input section 
     */
    public emptyInputLoad(): void{

        for(let j = 0; j < 3; j++){
            for(let i = 0; i < this.selectedPalette.LevelCount - 1; i++){
                this.displayRedBorder[j][i] = false;
            }
        }

        if(this.unsavedInputs.length == 0){
            for(let j = 0; j < this.selectedObjectiveList.length; j++){
                this.unsavedInputs[j] = [];
                for(let i = 1; i <= this.selectedPalette.LevelCount - 1; i++){
                    let zero: ObjectiveRangeValueObj = {dayMinValue: null, monthMinValue: null, weekMinValue: null};
                    this.unsavedInputs[j].push(zero);
                }
            }
        }
    
        if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){

            if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0){
                for(let j = 0; j < 3; j++){
                    for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                        if(i == 0){
                            this.preInputDisplays[j][i] = '0';
                        }
                        else {
                            this.preInputDisplays[j][i] = '--';
                        }
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1){
                for(let j = 0; j < 3; j++){
                    for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                        if(i == 0){
                            this.preInputDisplays[j][i] = '0';
                        }
                        else {
                            this.preInputDisplays[j][i] = '--';
                        }
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
                for(let j = 0; j < 3; j++){
                    for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                        if(i == 0){
                            this.preInputDisplays[j][i] = '0%';
                        }
                        else {
                            this.preInputDisplays[j][i] = '--';
                        }
                    }
                }
            }
            else{
                if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                    for(let j = 0; j < 3; j++){
                        for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                            if(i == 0){
                                this.preInputDisplays[j][i] = '00:00:00';
                            }
                            else {
                                this.preInputDisplays[j][i] = '--';
                            }
                        }
                    }
                }
                else{
                    for(let j = 0; j < 3; j++){
                        for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                            if(i == 0){
                                this.preInputDisplays[j][i] = '0';
                            }
                            else {
                                this.preInputDisplays[j][i] = '--';
                            }
                        }
                    }
                }
            }
        }
        else{
            if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0){
                for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                    if(i == 0){
                        this.preInputDisplays[0][i] = '0.00';
                    }
                    else {
                        this.preInputDisplays[0][i] = '--';
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1){
                for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                    if(i == 0){
                        this.preInputDisplays[0][i] = '0';
                    }
                    else {
                        this.preInputDisplays[0][i] = '--';
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
                for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                    if(i == 0){
                        this.preInputDisplays[0][i] = '0%';
                    }
                    else {
                        this.preInputDisplays[0][i] = '--';
                    }
                }
            }
            else{

                if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                    for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                        if(i == 0){
                            this.preInputDisplays[0][i] = '00:00:00';
                        }
                        else {
                            this.preInputDisplays[0][i] = '--';
                        }
                    }
                }
                else{
                    for(let i = 0; i < this.selectedPalette.LevelCount; i++){
                        if(i == 0){
                            this.preInputDisplays[0][i] = '0';
                        }
                        else {
                            this.preInputDisplays[0][i] = '--';
                        }
                    }
                }
            }
        }

        this.cdr.detectChanges();
    }

    /**
     * Function for loading the input section from the Objective that is being edited
     */
    public tabChangeLoad(): void{

        //I have to clonedeep a copy so I'm not effecting the selectedObjectiveList until the view is being saved
        if(this.unsavedInputs.length == 0){
            for (let i = 0; i < this.selectedObjectiveList.length; i++) {
                let objectiveDetailsCopy = cloneDeep(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails);
                this.unsavedInputs[i] = objectiveDetailsCopy;
            }
        }

        for(let j = 0; j < 3; j++){
            for(let i = 0; i < this.selectedPalette.LevelCount - 1; i++){
                this.displayRedBorder[j][i] = false;
            }
        }

        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 3 && this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
            this.preInputDisplays[0][0] = "00:00:00";
            this.preInputDisplays[1][0] = "00:00:00";
            this.preInputDisplays[2][0] = "00:00:00";
        }
        else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
            this.preInputDisplays[0][0] = "0%";
            this.preInputDisplays[1][0] = "0%";
            this.preInputDisplays[2][0] = "0%";
        }
        else{
            this.preInputDisplays[0][0] = "0";
            this.preInputDisplays[1][0] = "0";
            this.preInputDisplays[2][0] = "0";
        }

        //if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0){
            for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue - .01)).toString();

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue - .01)).toString();
                    this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue - .01)).toString();
                }

                this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue)).toString();

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue)).toString();
                    this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue)).toString();
                }
            }
        }
        else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1){
            for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue - .01)).toString();

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue - .01)).toString();
                    this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue - .01)).toString();
                }

                this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue)).toString();

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue)).toString();
                    this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue)).toString();
                }
            }
        }
        else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
            for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue - .01)).toString();

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue - .01)).toString();
                    this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue - .01)).toString();
                }

                this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--%" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue)).toString() + "%";

                if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                    this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--%" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue)).toString() + "%";
                    this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--%" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue)).toString() + "%";
                }
            }  
        }
        else{
            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                    this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : this.formatTime(this.unsavedInputs[this.tabIndex][i].dayMinValue, true);

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : this.formatTime(this.unsavedInputs[this.tabIndex][i].weekMinValue, true);
                        this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : this.formatTime(this.unsavedInputs[this.tabIndex][i].monthMinValue, true);
                    }

                    this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : this.formatTime(this.unsavedInputs[this.tabIndex][i].dayMinValue);

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : this.formatTime(this.unsavedInputs[this.tabIndex][i].weekMinValue);
                        this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : this.formatTime(this.unsavedInputs[this.tabIndex][i].monthMinValue);
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 3){
                for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                    this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].dayMinValue / 3600) - .01)).toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].weekMinValue / 3600) - .01)).toString();
                        this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : (this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].monthMinValue / 3600) - .01)).toString();
                    }
    
                    this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue / 3600)).toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue / 3600)).toString();
                        this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue / 3600)).toString();
                    }
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 2){
                for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                    this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].dayMinValue / 60) - .01)).toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].weekMinValue / 60) - .01)).toString();
                        this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null :(this.roundToTwoDecimalPlaces((this.unsavedInputs[this.tabIndex][i].monthMinValue / 60) - .01)).toString();
                    }
    
                    this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].dayMinValue / 60)).toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].weekMinValue / 60)).toString();
                        this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : (this.roundToTwoDecimalPlaces(this.unsavedInputs[this.tabIndex][i].monthMinValue / 60)).toString();
                    }
                }
            }
            else{
                for(let i = this.unsavedInputs[this.tabIndex].length - 1; i >= 0 ; i--){
                    this.inputDisplays[0][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? null : (this.unsavedInputs[this.tabIndex][i].dayMinValue - 1).toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.inputDisplays[1][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? null : (this.unsavedInputs[this.tabIndex][i].weekMinValue - 1).toString();
                        this.inputDisplays[2][(this.unsavedInputs[this.tabIndex].length - 1) - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? null : (this.unsavedInputs[this.tabIndex][i].monthMinValue - 1).toString();
                    }
    
                    this.preInputDisplays[0][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].dayMinValue == null) ? "--" : this.unsavedInputs[this.tabIndex][i].dayMinValue.toString();

                    if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
                        this.preInputDisplays[1][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].weekMinValue == null) ? "--" : this.unsavedInputs[this.tabIndex][i].weekMinValue.toString();
                        this.preInputDisplays[2][this.unsavedInputs[this.tabIndex].length - i] = (this.unsavedInputs[this.tabIndex][i].monthMinValue == null) ? "--" : this.unsavedInputs[this.tabIndex][i].monthMinValue.toString();
                    }
                }
            }
        }

        if(this.secondViewSaveClicked){
            this.highlightPartialColumn();
        }

        this.checkForAutoFill();

        this.cdr.detectChanges();
    }

     /**
     * Increments the display for the Input section
     * @param column the column from the front end, 0 for day, 1 for week, 2 for month
     * @param row the row from the front end display
     */
     public rangeInputChange(column: number, row: number){

        //only check to disable autofill when day is changed
        if (column == 0) {
            this.checkIfAutofilled();
        }

        //here i check for a special character and then set the red border display
        if (this.liveValidateInputBox(this.inputDisplays[column][row]) && this.inputDisplays[column][row] != ""){
            this.displayRedBorder[column][row] = true;
            this.inputBoxError = true;
            this.checkForAutoFill();
            this.secondSaveDisabled = true;
            return;
        }
        else {
            //This is for non special character input
            this.displayRedBorder[column][row] = false;

            if(!this.inputErrorCheck()){
                this.inputBoxError = false;
                this.secondSaveDisabled = false;
            }
        }

        //in here I take the new input and save it to the unsavedInputs, and I update the next range display
        if(this.inputDisplays[column][row] != "" && this.inputDisplays[column][row] != "." && this.inputDisplays[column][row] != ":"){
            if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0){
                this.preInputDisplays[column][row + 1] = (this.roundToTwoDecimalPlaces(((+this.inputDisplays[column][row]) + .01))).toString();

                switch(column){
                    case 0:
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 1: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 2: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    default:
                        return "0";
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1){
                this.preInputDisplays[column][row + 1] = (this.roundToTwoDecimalPlaces((+this.inputDisplays[column][row]) + .01)).toString();
                
                switch(column){
                    case 0:
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 1: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 2: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    default:
                        return "0";
                }
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
                this.preInputDisplays[column][row + 1] = (this.roundToTwoDecimalPlaces((+this.inputDisplays[column][row]) + .01)).toString();

                switch(column){
                    case 0:
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 1: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    case 2: 
                        this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1];
                        break;
                    default:
                        return "0";
                }
                this.preInputDisplays[column][row + 1] += "%";
            }
            else{
                if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                    //this is for hh:mm:ss metric types
                    if (/^\d{1,}:[0-5][0-9]:[0-5][0-9]$/.test(this.inputDisplays[column][row])) {
                        let [hours, minutes, seconds] = this.inputDisplays[column][row].split(':').map(Number);

                        let secondsCounter = 0;
                        secondsCounter += hours * 3600;
                        secondsCounter += minutes * 60;
                        secondsCounter += seconds;

                        secondsCounter++;

                        switch(column){
                            case 0:
                                this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = secondsCounter;
                                break;
                            case 1: 
                                this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = secondsCounter;
                                break;
                            case 2: 
                                this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = secondsCounter;
                                break;
                            default:
                                return "0";
                        }

                        this.preInputDisplays[column][row + 1] = this.formatTime(secondsCounter);
                    }
                }
                else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 3){
                    this.preInputDisplays[column][row + 1] = ((+this.inputDisplays[column][row]) + .01).toString();

                    switch(column){
                        case 0:
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1] * 3600;
                            break;
                        case 1: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1] * 3600;
                            break;
                        case 2: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1] * 3600;
                            break;
                        default:
                            return "0";
                    }
                }
                else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 2){
                    this.preInputDisplays[column][row + 1] = ((+this.inputDisplays[column][row]) + .01).toString();

                    switch(column){
                        case 0:
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1] * 60;
                            break;
                        case 1: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1] * 60;
                            break;
                        case 2: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1] * 60;
                            break;
                        default:
                            return "0";
                    }
                }
                else{
                    this.preInputDisplays[column][row + 1] = ((+this.inputDisplays[column][row]) + 1).toString();

                    switch(column){
                        case 0:
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = +this.preInputDisplays[column][row + 1];
                            break;
                        case 1: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = +this.preInputDisplays[column][row + 1];
                            break;
                        case 2: 
                            this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = +this.preInputDisplays[column][row + 1];
                            break;
                        default:
                            return "0";
                    }
                }
            }
        }
        else{
            //this happens if the input box is empty
            this.preInputDisplays[column][row + 1] = "--";

            switch(column){
                case 0:
                    this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].dayMinValue = null;
                    break;
                case 1: 
                    this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].weekMinValue = null;
                    break;
                case 2: 
                    this.unsavedInputs[this.tabIndex][this.selectedPalette.LevelCount - row - 2].monthMinValue = null;
                    break;
                default:
                    return "0";
            }
        }

        //this is the Change Detection and Validation checks
        this.inputOutOfOrderCheck(column);

        this.checkForAutoFill();

        this.saveInputChangeDetection();

        this.checkForEmptyColumns();
    
        this.cdr.detectChanges();
    }

    /**
     * Function for returning a formatted time string
     * @param seconds this is the amount of seconds you want converted to hh:mm:ss
     * @param decrement defaults to false, if true it minuses one second. 
     */
    private formatTime(seconds: number, decrement: boolean = false): string {
        let formattedTime = ""
        if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
            if (decrement) {
                seconds -= 1;
            }
      
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            let remainingSeconds = seconds % 60;
    
            let formattedHours = String(hours).padStart(2, '0');
            let formattedMinutes = String(minutes).padStart(2, '0');
            let formattedSeconds = String(remainingSeconds).padStart(2, '0');
            formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        }
        else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 3){
            if (decrement){
                formattedTime = String(this.roundToTwoDecimalPlaces(seconds / 3600)-.01) ;
            }
            else{
                formattedTime = String(this.roundToTwoDecimalPlaces(seconds / 3600));
            }
            
        }
        else if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 2){
            if (decrement){
                formattedTime = String(this.roundToTwoDecimalPlaces(seconds / 60)-.01) ;
            }
            else{
                formattedTime = String(this.roundToTwoDecimalPlaces(seconds / 60));
            }
        }
        else{
            if (decrement) {
                seconds -= 1;
            }
            formattedTime = String(seconds)
        }
      
        return formattedTime;
    }

    /**
     * Function for rounding decimals to two places
     * @param number number that you want rounded to two decimal places
     */
    private roundToTwoDecimalPlaces(num: number): number {
        let roundedNum = Math.round(num * 100) / 100; // Multiply by 100, round, and then divide by 100
        return roundedNum;
    }

    /**
     * Load the curNotifications items back into the proper locations in the selectedObjectiveList objects
     */
    public populateObjectiveListWithAlerts() {

        //Empy all the alert lists first
        this.selectedObjectiveList.forEach(obj => {
            obj.combinedObj.AlertsList.forEach((alert, idx, list) => {
                list[idx] = [];
            })
        });

        this.curNotificationList.forEach(alert => {
            this.selectedObjectiveList.forEach((obj, index, arr) => {
                if((obj.combinedObj.AssignedLevel == alert.SendToLevel) || obj.combinedObj.AssignedLevel == 6){
                    arr[index].combinedObj.AlertsList[0].push(alert);
                }
            })
        });
    }

    checkForUnsavedChanges() {
        let hasUpdates = false;
        let isNewObjective = false;
    
        this.selectedObjectiveList.forEach((objective, index) => {
            const originalObjective = this.originalEditObjectiveCopy[index];

            if (objective.combinedObj.ObjectiveID === 0) {
                isNewObjective = true;
            }
    
            if (originalObjective) {
                objective.combinedObj.ObjectiveDetails.forEach((detail, detailIndex) => {
                    const originalDetail = originalObjective.combinedObj.ObjectiveDetails[detailIndex];
    
                    if (originalDetail) {
                        // Compare all keys dynamically
                        for (const key in detail) {
                            if (detail.hasOwnProperty(key) && originalDetail.hasOwnProperty(key)) {
                                if (detail[key] !== originalDetail[key]) {
                                    hasUpdates = true;
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        });
    
        if (hasUpdates && !isNewObjective) {
            this.toastrManager.showToaster("success", this.getLocalizationString("Performance_Updated_Successfully", "Performance range updated successfully"));
        }
    }
           
    /**
     * Saves the edited ranges to the objective object that is being edited. Does not save to the backend.
     */
    public onSaveClick(): void{
        if(this.saveInputValidation()){
            this.selectedObjectiveList.forEach((item, index) => {
                item.combinedObj.ObjectiveDetails = this.unsavedInputs[index];
                item.combinedObj.ObjectivePaletteID = this.selectedPalette.ObjectivePaletteID;
            });

            this.unsavedInputs = [];
            this.secondSaveDisabled = true;
            this.secondViewSaveClicked = false;
            this.showBackValidationMessage = false;
            this.tabIndex = 0;

            this.filterLevelSelection = [];
            this.filterNotificationTypeSelection = [];
            this.notificationGridOptions = null;
            this.populateObjectiveListWithAlerts();
            this.initNotificationList = [...this.curNotificationList];
            this.isObjectiveChanged();
            this.checkForUnsavedChanges()

            this.editPhase = 1;
        }
    }


    /**
    * Gets the coordinates for the display values to go around the gauge images.
    * @param top Set to true to get the value for the "top" property, false to get the "left" property
    * @param index The index value of the display value to get the dimensions for
    */
    getObjectiveFieldPosition(top, index) {
        let positionsArray;

        if (this.metricAbrDict[this.selectedObjective.MetricID].Direction == 0)
            positionsArray = this.positionsReverse[this.selectedPalette.LevelCount - 2];
        else
            positionsArray = this.positions[this.selectedPalette.LevelCount - 2];

        if (positionsArray.length <= index)
            return;

        return positionsArray[index][top ? 0 : 1] + "px";
    }

    /**
    * Returns the zero value displayed in the center of the gauge and at the opposite to "and up"
    * */
    gaugeFormattedZero() {
        switch (this.metricAbrDict[this.selectedObjective.MetricID].NumericType) {
            case 0: // Currency
                return "0.00";
            case 1: // Number
                return "0";
            case 2: // Percent
                return "0%";
            case 3: // Time
                switch (this.metricAbrDict[this.selectedObjective.MetricID].TimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return "0";
                    case 4: // Time
                        return "00:00:00";
                    default:
                        return "0";
                }
            default:
                return "0";
        }
    }

    getObjectiveColor(color, index) {
        if (this.metricAbrDict[this.selectedObjective.MetricID].Direction == 0)
            return color.HexColor;
        else
            return this.selectedPalette.ObjectiveColors[this.selectedPalette.ObjectiveColors.length - (index + 1)].HexColor;
    }

    /**
     * Function to validate the string format for each metric type. Returns true or false depending if it matches the format for a certain metric type
     * */
    private liveValidateInputBox(input: string): boolean{
        //Here I need to check each metric type and validate the input boxes depending on the metric type

        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0){
            //currency this should accept numbers and . but not :
            return !/^\d*\.?\d*$/.test(input);
        }
        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1){
            return !/^\d*\.?\d*$/.test(input);
        }
        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
            return !/^\d*\.?\d*$/.test(input);
        }
        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 3){
            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                //this is hh:mm:ss and should accept numbers and : but not . 

                return !/^[0-9:]+$/.test(input);
            }

            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 3){
                //this is hours and should only accept numbers

                return !/^[0-9]+$/.test(input);
            }

            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 2){
                //this is Minutes and should only accept numbers 

                return !/^[0-9]+$/.test(input);
            }

            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 1){
                //this is Seconds and should only accept numbers 

                return !/^[0-9]+$/.test(input);
            }
        } 
    }

    /**
     * Changes all range values of the selected objectives to null
     */
    public clearAllRanges(): void{
        this.selectedObjectiveList.forEach(objective => {
            objective.combinedObj.ObjectiveDetails = [];

            objective.combinedObj.ObjectivePaletteID = 0;
        });

        this.selectedPalette = this.standardOptions[0]; //set the range to default selection
        
    }

    /**
     * Clears all Alert data for the second view
     */
    public clearAllAlerts(): void{
        for(let j = 0; j < this.selectedObjectiveList.length; j++){
            for(let i = 0; i < this.selectedObjectiveList[j].combinedObj.AlertsList.length; i++){
                this.selectedObjectiveList[j].combinedObj.AlertsList[i] = [];
            }
        }
    }

    /**
     * This is the initial change detection for the input boxes. Checks the input boxes for one valid input and then enable the save button
     * */
    public saveInputChangeDetection(): void{
        //here I check the unsavedInputs for if there are any filled out input boxes if their are I enable the save button
        if(!this.inputErrorCheck()){
            for(let i = 0; i < this.selectedObjectiveList.length; i++){
                for(let j = 0; j < this.unsavedInputs[i].length; j++){
                    if(this.unsavedInputs[i][j].dayMinValue != null || this.unsavedInputs[i][j].weekMinValue != null || this.unsavedInputs[i][j].monthMinValue != null){
                        this.secondSaveDisabled = false;
                        this.showBackValidationMessage = true;
                        return;
                    }
                }
            }
        }

        this.secondSaveDisabled = true;
        this.showBackValidationMessage = false;
    }

    /**
     * Main function for validation messages in the second view. Checks input boxes for incorrect formats, partially filled out tabs, partially filled out columns, and empty tabs
     * */
    public saveInputValidation(): boolean{
        if(!this.secondViewSaveClicked){
            this.secondViewSaveClicked = true;
        }

        //Here I need to check for any invalid inputs and then display the wrong format error
        if(this.inputBoxError){
            this.showValidationModal(
                this.getLocalizationString('Wrong_Format_Header', "Wrong Format"), 
                'user-warning',
                this.getLocalizationString('Wrong_Format_Message', "Enter the value in required format"),
                this.getLocalizationString('Okay', "Okay"),
                false, 
                '420px',
                '184px',
                () => {},
                () => {}
            );

            this.highlightPartialColumn();

            return false;
        }

        //here I'm checking the input displays for wrong formats
        let showWrongFormat = false;
        for(let j = 0; j < 3; j++){
            for(let i = 0; i < this.inputDisplays[j].length; i++){
                if(!this.validateInputFormat(this.inputDisplays[j][i]) && this.inputDisplays[j][i] != null && this.inputDisplays[j][i] != ""){
                    //set a  red display and then show the wrong format message
                    this.displayRedBorder[j][i] = true;
                    showWrongFormat = true;
                }
            }
        }

        if(showWrongFormat){
            this.showValidationModal(
                this.getLocalizationString('Wrong_Format_Header', "Wrong Format"), 
                'user-warning',
                this.getLocalizationString('Wrong_Format_Message', "Enter the value in required format"),
                this.getLocalizationString('Okay', "Okay"),
                false, 
                '420px',
                '184px',
                () => {},
                () => {}
            );

            this.highlightPartialColumn();

            return false;
        }

        //here i check that at least one row is filled out for every tab
        let showEmptyValidation = false;
        let showPartialValidation = false;
        let invalidEmptyObjectiveNames: string[] = [];
        let invalidPartialObjectiveNames: string[] = [];
        for(let i = 0; i < this.selectedObjectiveList.length; i++){
            let rowCount = this.selectedPalette.LevelCount - 1;
            let dayColumnCount = 0;
            let weekColumnCount = 0;
            let monthColumnCount = 0;

            //this is to check the day values
            for(let j = 0; j < rowCount; j++){
                if(this.unsavedInputs[i][j].dayMinValue != null){
                    dayColumnCount++;
                }

                if(this.unsavedInputs[i][j].weekMinValue != null){
                    weekColumnCount++;
                }

                if(this.unsavedInputs[i][j].monthMinValue != null){
                    monthColumnCount++;
                }
            }

            if(weekColumnCount == 0 && dayColumnCount == 0 && monthColumnCount == 0){
                invalidEmptyObjectiveNames.push(this.groupTypes[this.selectedObjectiveList[i].assignments.coreAssignAtType][this.selectedObjectiveList[i].assignments.coreAssignAtLevel - 1]?.GroupTypeName)
                showEmptyValidation = true;
            }

            if(((dayColumnCount < rowCount && dayColumnCount > 0) || 
                (weekColumnCount < rowCount && weekColumnCount > 0) || 
                (monthColumnCount < rowCount && monthColumnCount > 0))){

                invalidPartialObjectiveNames.push(this.groupTypes[this.selectedObjectiveList[i].assignments.coreAssignAtType][this.selectedObjectiveList[i].assignments.coreAssignAtLevel - 1]?.GroupTypeName);
                showPartialValidation = true;
            }
        }

        if(showEmptyValidation){
            let phrase = " ";
            if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){

                for(let i = 0; i < invalidEmptyObjectiveNames.length; i++){
                    phrase += invalidEmptyObjectiveNames[i];

                    if(invalidEmptyObjectiveNames.length == 1){
                        phrase += " ";
                    }
                    if(i == invalidEmptyObjectiveNames.length - 2 && invalidEmptyObjectiveNames.length == 2){
                        phrase += " " + this.getLocalizationString('And', "And").toLocaleLowerCase() + " ";
                    }
                    if (i == invalidEmptyObjectiveNames.length - 2 && invalidEmptyObjectiveNames.length > 2) {
                        phrase += ", " + this.getLocalizationString('And', "And").toLocaleLowerCase() + " ";
                    }
                    if(i != invalidEmptyObjectiveNames.length - 2 && i != invalidEmptyObjectiveNames.length - 1){
                        phrase += ", ";
                    }
                } 
            }

            this.showValidationModal(
                this.getLocalizationString('Ranges_Values_Required_Header', "Performance Ranges"), 
                'user-warning',
                phrase != ' ' ? this.getLocalizationString('Switch_Group_Message', "Range values for objectives still need to be set.", phrase) : this.getLocalizationString('Set_Objective_Range','Set Objective range before saving'),
                this.getLocalizationString('Okay', "Okay"),
                false, 
                '420px',
                '184px',
                () => {},
                () => {}
            );

            this.highlightPartialColumn();

            this.secondSaveDisabled = true;

            return false;
        }

        if(showPartialValidation){
            let phrase = " ";
            if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){

                for(let i = 0; i < invalidPartialObjectiveNames.length; i++){
                    phrase += invalidPartialObjectiveNames[i];

                    if(invalidPartialObjectiveNames.length == 1){
                        phrase += " ";
                    }
                    if(i == invalidPartialObjectiveNames.length - 2){
                        phrase += this.getLocalizationString('And', ", and") + " ";
                    }
                    if(i != invalidPartialObjectiveNames.length - 2 && i != invalidPartialObjectiveNames.length - 1){
                        phrase += ", ";
                    }
                } 
            }

            this.showValidationModal(
                this.getLocalizationString('Performance_Ranges', "Performance Ranges"), 
                'user-warning',
                this.getLocalizationString('Performance_Ranges_Message', "Enter a set of values for each objective", phrase),
                this.getLocalizationString('Okay', "Okay"),
                false, 
                '420px',
                '184px',
                () => {},
                () => {}
            );

            this.highlightPartialColumn();

            this.secondSaveDisabled = true;

            return false;
        }

        return true;
    }

    /**
     * Function to check the format of different metric types
     * @param input String variable that you want tested
     * */
    private validateInputFormat(input: string): boolean{
        if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 0 || this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 1 || this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
            //currency, count, percentage

            //check for only one period 
            if(/.*\..*\..*/.test(input)) {
                return false;
            }

            return true;
        }
        else{
            if(this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                //hh:mm:ss
                if(!/^\d{1,}:[0-5][0-9]:[0-5][0-9]$/.test(input)){
                    return false;
                }

                return true;
            }
            else{
                //seconds, hours, minutes
                if(/.*\..*\..*/.test(input)) {
                    return false;
                }

                return true;
            }
        }
    }

    /**
     * Function for showing a custom validation modal.
     * @param validationTitle String variable for the Title of the modal
     * @param validationType String variable for the modal type. Most on this page are 'user-warning'
     * @param validationMessage String variable for the message of the modal
     * @param validationPrimaryButtonText String variable for the text of the primary button on the modal
     * @param validationIncludeCloseButton Boolean variable for if you want to include a secondary button on the modal. defaults to False
     * @param width String variable for the height of the modal
     * @param height String variable for the width of the modal
     * @param primaryButtonClickedFunc Function that is run when the user clicks on the primary button. if you want nothing to happen leave an empty function here
     * @param defaultFunc Function that is run anytime the modal pops up. this will always be run. if you want nothing to happen leave an empty function here 
     * @param closeButtonText Optional string variable for the secondary button on the modal. Need to set validationIncludeCloseButton to true before using this optional variable. 
     * */
    public showValidationModal(
        validationTitle: string, 
        validationType: string,
        validationMessage: string, 
        validationPrimaryButtonText: string, 
        validationIncludeCloseButton: boolean = false, 
        width: string,
        height: string,
        primaryButtonClickedFunc: () => void,
        defaultFunc: () => void,
        closeButtonText?: string,
    ): void{
        //validationMessageModalRef

        if (!this.validationMessageModalRef) {
            let dialogData;
            if(validationIncludeCloseButton){
                dialogData = {
                    title: validationTitle,
                    type: validationType, //MessageTypes from cxone-components/modal
                    message: validationMessage,
                    primaryButtonText: validationPrimaryButtonText,
                    closeButtonText: closeButtonText
                };
            }
            else{
                dialogData = {
                    title: validationTitle,
                    type: validationType, //MessageTypes from cxone-components/modal
                    message: validationMessage,
                    primaryButtonText: validationPrimaryButtonText
                };
            }
            
            this.validationMessageModalRef = this.dialogSrvc.open(MessageModalComponent, {
                width: width,
                height: height,
                data: dialogData,
                styleClass: "cx-one-ui"
            });
            
            this.validationMessageModalRef.onClose.subscribe(value => {
                if (value){
                    primaryButtonClickedFunc();//Enter the function that you want to happen after the user clicks okay
                }
                defaultFunc();
                this.validationMessageModalRef = null;
            });
        }
    }

     /**
     * Function to save the range selection when the range dropdown is opened
     * */
    public saveRangeDropdownSelection(): void{
        this.previousRangeSelection = this.selectedPalette;
    }

    /**
     * Function to show the validation message when a new range is selected and data would be removed. 
     * */
    public newRangeDropdownSelection(): void{
        if(this.checkForAnyInputs()){
            this.newRangeSelection = this.selectedPalette;

            let index = 0;
            for(let i = 0; i < this.standardOptions.length; i++){
                if(this.standardOptions[i].ObjectivePaletteID == this.previousRangeSelection.ObjectivePaletteID){
                    index = i
                }
            }

            this.selectedPalette = this.standardOptions[index];
            this.cdr.detectChanges();

            this.showValidationModal(
                this.getLocalizationString('Changing_Range_Header', "Changing Range"), 
                'user-warning',
                this.getLocalizationString('Changing_Range_Message', "Changing the range setting will remove all set values, Do you want to continue?"),
                this.getLocalizationString('Yes', "Yes"),
                true, 
                '420px',
                '184px',
                () => {
                    this.selectedPalette = this.newRangeSelection;
                    this.rangesChanged();
                },
                () => {
                    this.displayRangeDropdown = false;
                    this.cdr.detectChanges();
                    this.displayRangeDropdown = true;
                    this.cdr.detectChanges();
                }, 
                this.getLocalizationString('Cancel', "Cancel")
            );
        }
        else{
            this.rangesChanged();
        }
    }

    /**
     * Function to check that their are inputs for every tab on the second view. 
     * */
    public checkForAnyInputs(): boolean{
        for(let i = 0; i < this.selectedObjectiveList.length; i++){
            for(let j = 0; j < this.unsavedInputs[i].length; j++){
                if(this.unsavedInputs[i][j].dayMinValue != null || this.unsavedInputs[i][j].weekMinValue != null || this.unsavedInputs[i][j].monthMinValue != null){
                    return true;
                }
            }
        }

        return false;
    }

    /**
     *  This function loops through the current tab of the second view and checks for partially filled out columns
     * */
    public checkForPartiallyFilledOutColumns(): boolean{
        //loop through each of the columns if the metric is count
        if(this.metricAbrDict[this.selectedObjective.MetricID].MetricObjectiveType == 0){
            //this is for count 

            for(let i = 0; i < 3; i++){
                let columnCount = 0;
                for(let j = 0; j < this.selectedPalette.LevelCount - 1; j++){
                    if(this.inputDisplays[i][j] != null && this.inputDisplays[i][j] != ""){
                        columnCount++;
                    }
                }

                if(columnCount > 0 && columnCount < this.selectedPalette.LevelCount - 1){
                    //this means partially filled out column so return false and call the highlight partial column
                    this.highlightPartialColumn();
                    return true;
                }
            }

            return false;
        }
        else{
            //this is for normalized
            let columnCount = 0;
            for(let j = 0; j < this.selectedPalette.LevelCount - 1; j++){
                if(this.inputDisplays[0][j] != null && this.inputDisplays[0][j] != ""){
                    columnCount++;
                }
            }

            if(columnCount > 0 && columnCount < this.selectedPalette.LevelCount - 1){
                //this means partially filled out column so return false
                this.highlightPartialColumn();
                return true;
            }

            return false;
        }
    }

    /**
     *  Function to loop through the current tab and highlight empty input boxes in a partially filled out column
     * */
    private highlightPartialColumn(): void{
        for(let column = 0; column < 3; column++){
            //First check the unsaved inputs for that given column
            let dayCount = 0;
            let weekCount = 0;
            let monthCount = 0;
            let rowCount = this.selectedPalette.LevelCount - 1

            for(let i = 0; i < rowCount; i++){
                switch(column){
                    case 0:
                        this.unsavedInputs[this.tabIndex][i].dayMinValue != null && dayCount++;
                        break;
                    case 1: 
                        this.unsavedInputs[this.tabIndex][i].weekMinValue != null && weekCount++;
                        break;
                    case 2: 
                        this.unsavedInputs[this.tabIndex][i].monthMinValue != null && monthCount++;
                        break;
                    default:
                        return;
                }
            }

            if((dayCount > 0 && dayCount < rowCount) || (weekCount > 0 && weekCount < rowCount) || (monthCount > 0 && monthCount < rowCount)){
                //this means that a column is partially filled out
                //need to loop through the column and then highlight the non filled out ones. 
                for(let i = 0; i < rowCount; i++){
                    switch(column){
                        case 0:
                            (this.inputDisplays[0][i] == null || this.inputDisplays[0][i] == "") && (this.displayRedBorder[0][i] = true);
                            break;
                        case 1: 
                            (this.inputDisplays[1][i] == null || this.inputDisplays[1][i] == "") && (this.displayRedBorder[1][i] = true);
                            break;
                        case 2: 
                            (this.inputDisplays[2][i] == null || this.inputDisplays[2][i] == "") && (this.displayRedBorder[2][i] = true);
                            break;
                        default:
                            return;
                    }
                }
            }
        }
    }

    /**
     *  Main function for Change detection. Looks through the selectedObjective object to make sure each required field is filled out
     * */
    public isObjectiveChanged(): boolean{

        if(this.selectedObjective.combinedObj.ObjectiveID == 0){
            //this is for the create case
            this.checkCreateForChanges();
            //check for name
            if(
                this.selectedObjective.ObjectiveName == "" || this.objectiveNameError != 0 ||
                (this.currentMetricType == 0 && (this.selectedObjective.assignments.emp.length == 0 && !this.selectedObjective.assignments.empAssignAll)) ||
                (this.currentMetricType == 0 && (this.selectedObjective.assignments.rec.length == 0 && !this.selectedObjective.assignments.recAssignAll)) ||
                this.selectedObjective.combinedObj.ObjectivePaletteID == 0 || this.selectedObjective.combinedObj.ObjectivePaletteID == null ||
                this.selectedObjectiveList.some(objective => objective.combinedObj.ObjectiveDetails.length == 0) ||
                this.selectedObjective.combinedObj.StartDate == undefined
            ){
                return false;
            }

            //check the objective details
            for(let i = 0; i < this.selectedObjectiveList.length; i++){
                //now I need to see if the objectiveDetails has data in it. if all the objective details for the newly created optional
                //if all of them don't have stuff in them then return true
                for(let j = 0; j < this.selectedObjectiveList[i].combinedObj.ObjectiveDetails.length; j++){
                    if(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].dayMinValue == null && this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].weekMinValue == null && this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].monthMinValue == null){
                        //this means there is a partial filled or empty column.
                        return false;
                    }
                }
            }

            //Check Count Objective
            if (this.currentMetricType != 1) {
                //Check level selection
                if (this.selectedGroupLevel == null)
                    return false;

                //Check selected assign type for required assignments
                if (this.selectedGroupLevel != null && this.selectedObjective.assignments.coreAssignAtType == 'emp') {
                    if (this.selectedObjective.assignments.emp.length == 0)
                        return false;
                }
                if (this.selectedGroupLevel != null && this.selectedObjective.assignments.coreAssignAtType == 'rec') {
                    if (this.selectedObjective.assignments.rec.length == 0)
                        return false;
                }
            }

            return true;
        }
        else{
            if(
                this.selectedObjective.ObjectiveName == "" || this.objectiveNameError != 0 ||
                (this.currentMetricType == 0 && (this.selectedObjective.assignments.emp.length == 0 && !this.selectedObjective.assignments.empAssignAll)) ||
                (this.currentMetricType == 0 && (this.selectedObjective.assignments.rec.length == 0 && !this.selectedObjective.assignments.recAssignAll)) ||
                this.selectedObjective.combinedObj.StartDate == undefined ||
                this.selectedObjective.combinedObj.ObjectivePaletteID == 0 || this.selectedObjective.combinedObj.ObjectivePaletteID == null ||
                this.selectedObjectiveList.some(objective => objective.combinedObj.ObjectiveDetails.length == 0) ||
                this.checkforEmptyObjectiveDetails()
            ){
                this.showCancelValidationMessage = true;
                sendMessageCXOne({ hasNonSavedChanges: true });
                return false;
            }

            //Check Count Objective
            if (this.currentMetricType != 1) {
                //Check selected assign type for required assignments
                if (this.selectedGroupLevel != null && this.selectedObjective.assignments.coreAssignAtType == 'emp') {
                    if (this.selectedObjective.assignments.emp.length == 0)
                        return false;
                }
                if (this.selectedGroupLevel != null && this.selectedObjective.assignments.coreAssignAtType == 'rec') {
                    if (this.selectedObjective.assignments.rec.length == 0)
                        return false;
                }
            }

            //this is for the edit case
            if(this.originalEditObjectiveCopy[0].ObjectiveName.trim().replace(/\s+/g, ' ') != this.selectedObjective.ObjectiveName.trim().replace(/\s+/g, ' ') && this.selectedObjective.ObjectiveName != ""){
                sendMessageCXOne({ hasNonSavedChanges: true });
                return true;
            }

            //check assignments - this will cover emp/rec groups, level, and group type
            if(
                JSON.stringify(this.originalEditObjectiveCopy[0].assignments) != JSON.stringify(this.selectedObjective.assignments)
            ){
                sendMessageCXOne({ hasNonSavedChanges: true });
                return true;
            }

            //compare the objectiveDetails for any difference
            if(this.originalEditObjectiveCopy.length <= this.selectedObjectiveList.length){
                for(let i = 0; i < this.originalEditObjectiveCopy.length; i++){
                    if(JSON.stringify(this.originalEditObjectiveCopy[i].combinedObj.ObjectiveDetails) != JSON.stringify(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails)){
                        sendMessageCXOne({ hasNonSavedChanges: true });
                        return true;
                    }
                }
            }

            if(this.selectedObjectiveList.length > this.originalEditObjectiveCopy.length){
                //now check to make sure that the objectiveDetails are filled out
                for(let i = this.originalEditObjectiveCopy.length; i < this.selectedObjectiveList.length; i++){
                    //now I need to see if the objectiveDetails has data in it. if all the objective details for the newly created optional
                    //if all of them don't have stuff in them then return true
                    for(let j = 0; j < this.selectedObjectiveList[i].combinedObj.ObjectiveDetails.length; j++){
                        if(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].dayMinValue == null && this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].weekMinValue == null && this.selectedObjectiveList[i].combinedObj.ObjectiveDetails[j].monthMinValue == null){
                            //this means there is a partial filled or empty column.
                            sendMessageCXOne({ hasNonSavedChanges: true });
                            return true;
                        }
                    }
                }
            }

            //This is a edit case check for when the user adds optional assign group cards. 
            if((this.originalEditObjectiveCopy.length < this.selectedObjectiveList.length) || (this.originalEditObjectiveCopy.length > this.selectedObjectiveList.length)){
                sendMessageCXOne({ hasNonSavedChanges: true });
                return true;
            }

            //check the date for a change
            let originalDate = new Date(this.originalEditObjectiveCopy[0].combinedObj.StartDate + "Z"); //specify UTC time
            if(this.selectedObjective.combinedObj.StartDate.getDate() != originalDate.getDate() || this.selectedObjective.combinedObj.StartDate.getFullYear() != originalDate.getFullYear() || this.selectedObjective.combinedObj.StartDate.getMonth() != originalDate.getMonth()){
                sendMessageCXOne({ hasNonSavedChanges: true });
                return true;
            }

            //check notification table for changes
            for(let i = 0; i < this.originalEditObjectiveCopy.length; i++){
                if(JSON.stringify(this.originalEditObjectiveCopy[i].combinedObj.AlertsList) != JSON.stringify(this.selectedObjectiveList[i].combinedObj.AlertsList)){
                    sendMessageCXOne({ hasNonSavedChanges: true });
                    return true;
                }
            }
            
            //if none of the checks above return true then return false as default
            sendMessageCXOne({ hasNonSavedChanges: false });
            return false;
        }
        
    }

    /**
     *  Function that loops through the input boxes to see if there are any input boxes with red borders/errors
     * */
    private inputErrorCheck(): boolean{

        let inputErrorCount = 0;

        for(let i = 0; i < this.displayRedBorder.length; i++){
            for(let j = 0; j < this.displayRedBorder[i].length; j++){
                if(this.displayRedBorder[i][j]){
                    inputErrorCount++;
                }
            }
        }

        if(inputErrorCount > 0){
            return true;
        }

        return false;
    }

    /**
     *  Function to loop through the input boxes and highlight any input boxes that are lower then it's preInputValue
     * @param column Number variable for the column that you want checked. 
     * */
    public inputOutOfOrderCheck(column: number): void{

        // I need to scan the whole column and then highlight certain boxes
        for(let i = this.selectedPalette.LevelCount - 2; i > 0; i--){
            let input;
            let preInput;

            if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 3 && this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                if(/^\d{1,}:[0-5][0-9]:[0-5][0-9]$/.test(this.inputDisplays[column][i])){
                    let [hours, minutes, seconds] = this.inputDisplays[column][i].split(':').map(Number);

                    let secondsCounter = 0;
                    secondsCounter += hours * 3600;
                    secondsCounter += minutes * 60;
                    secondsCounter += seconds;

                    input = secondsCounter;

                    [hours, minutes, seconds] = this.preInputDisplays[column][i].split(':').map(Number);

                    secondsCounter = 0;
                    secondsCounter += hours * 3600;
                    secondsCounter += minutes * 60;
                    secondsCounter += seconds;

                    preInput = secondsCounter;
                }
                else{
                    continue;
                }                
            }
            else if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 2){
                input = +this.inputDisplays[column][i];
                preInput = +this.preInputDisplays[column][i].replaceAll("%", '');
            }
            else{
                input = +this.inputDisplays[column][i];
                preInput = +this.preInputDisplays[column][i];
            }

            if(input <= preInput){
                this.displayRedBorder[column][i] = true;
                this.secondSaveDisabled = true;
            }
            else{
                if(this.displayRedBorder[column][i] == true){
                    this.displayRedBorder[column][i] = false;
                }
            }
        }
    }

    /**
     *  Function to loop through the day column to make sure all the values in the day column are filled out correctly and then it will enable the autofill button
     * */
    public checkForAutoFill(): boolean{
        for(let i = 0; i < this.selectedPalette.LevelCount - 1; i++){
            if(this.metricAbrDict[this.selectedObjective.MetricID].NumericType == 3 && this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4){
                if(!/^\d{1,}:[0-5][0-9]:[0-5][0-9]$/.test(this.inputDisplays[0][i]) || this.displayRedBorder[0][i] == true){
                    this.enableWeekAutoFill = false;
                    this.enableMonthAutoFill = false;
                    return;
                }
            }
            else{
                if(this.inputDisplays[0][i] == null || this.inputDisplays[0][i] == "" || this.displayRedBorder[0][i] == true){
                    this.enableWeekAutoFill = false;
                    this.enableMonthAutoFill = false;
                    return;
                }
            }
        }
    }

    /**
     *  Function to check if week and month input values match the autofilled calculations
     * */
    public checkIfAutofilled(): void {
        // disables autofill if the display values already contain the autofilled calculations
        for (let i = 0; i < this.selectedPalette.LevelCount - 1; i++) {
            let dayValue = this.convertFormattedValueToNumber(this.inputDisplays[0][i]);
            if (this.inputDisplays[1][i] == this.convertNumberToFormattedValue(dayValue * 5) || this.inputDisplays[0][i] == "" || this.inputDisplays[0][i] == null) {
                this.enableWeekAutoFill = false;
            }
            else {
                this.enableWeekAutoFill = true;
                break;
            }
        }
        for (let i = 0; i < this.selectedPalette.LevelCount - 1; i++) {
            let dayValue = this.convertFormattedValueToNumber(this.inputDisplays[0][i]);
            if (this.inputDisplays[2][i] == this.convertNumberToFormattedValue(dayValue * 20) || this.inputDisplays[0][i] == "" || this.inputDisplays[0][i] == null) {
                this.enableMonthAutoFill = false;
            }
            else {
                this.enableMonthAutoFill = true;
                break;
            }
        }
    }

    /**
     * Saves the new/edited Objectives and sends it to the backend - returns user to the landing page
     */
    public async saveObjectives() {
        this.showSpinner = true;

        //If an alert has a temporary ID, restore it to 0 so the backend can save it
        this.selectedObjectiveList.forEach(obj => {
            obj.combinedObj.AlertsList[0].forEach((alert, idx, arr) => {
                if(alert.ObjectiveAlertID < 0){
                    arr[idx].ObjectiveAlertID = 0;
                }
            });
        });

        if (this.selectedObjective.assignments.emp.length == 0 && this.selectedObjective.assignments.empLevelMin != 0)
            this.defaultAssignAllLevels("emp");
        if (this.selectedObjective.assignments.rec.length == 0 && this.selectedObjective.assignments.recLevelMin != 0)
            this.defaultAssignAllLevels("rec");

        let objectiveToBeSaved: ObjectivesSaveObject = {
            assignedObj: this.selectedObjective.assignments,
            editedList: this.selectedObjectiveList.map(item => item.combinedObj),
            metricID: this.selectedObjective.MetricID,
            objectiveName: this.selectedObjective.ObjectiveName.trim().replace(/\s+/g, ' ')
        };

        let response = await this.objectivesService.saveObjective(objectiveToBeSaved,
            this.metricAbrDict[this.selectedObjective.MetricID].NumericType);
        if(response.status_code >= 200 && response.status_code < 300){
            await this.loadObjectives();
            this.curObjectiveCount = 0; //The count label will be inaccurate unless it's reset

            let containsNewObjective = this.assignmentData.some(objective => objective.combinedObj.ObjectiveID == response.data[0]);

            if(!containsNewObjective){
                for(let i = 0; i < objectiveToBeSaved.editedList.length; i++){
                    let newlyCreatedObjective: ObjectiveAssignmentDataObj = {
                        assignments: objectiveToBeSaved.assignedObj,
                        combinedObj: objectiveToBeSaved.editedList[i],
                        MetricID: objectiveToBeSaved.metricID,
                        ObjectiveName: objectiveToBeSaved.objectiveName
                    };
                    newlyCreatedObjective.combinedObj.ObjectiveID = response.data[i];
                    newlyCreatedObjective.assignments.coreAssignAtLevel = objectiveToBeSaved.editedList[i].AssignedLevel;
                    newlyCreatedObjective.assignments.coreAssignAtType = objectiveToBeSaved.editedList[i].AssignedType;

                    if (this.metricAbrDict[newlyCreatedObjective.MetricID].NumericType == 2) {
                        for(let j = 0; j < newlyCreatedObjective.combinedObj.ObjectiveDetails.length; j++){
                            if (newlyCreatedObjective.combinedObj.ObjectiveDetails[j].dayMinValue != null)
                                newlyCreatedObjective.combinedObj.ObjectiveDetails[j].dayMinValue *= 100;
                            else if (newlyCreatedObjective.combinedObj.ObjectiveDetails[j].weekMinValue != null)
                                newlyCreatedObjective.combinedObj.ObjectiveDetails[j].weekMinValue *= 100;
                            else if (newlyCreatedObjective.combinedObj.ObjectiveDetails[j].monthMinValue != null)
                                newlyCreatedObjective.combinedObj.ObjectiveDetails[j].monthMinValue *= 100;
                        }
                    }
                    
                    if(i > 0){
                        newlyCreatedObjective.combinedObj.GroupingID = response.data[0];
                    }

                    if(!(this.assignmentData.some(o=>o.combinedObj.ObjectiveID == newlyCreatedObjective.combinedObj.ObjectiveID && o.combinedObj.GroupingID== newlyCreatedObjective.combinedObj.GroupingID))){
                        this.assignmentData.push(cloneDeep(newlyCreatedObjective));
                    }
                }
            }

            this.agGrid?.api.setGridOption('rowData', this.assignmentData);
            this.showSpinner = false;
            let newObjectiveObject = this.isNewObjective; //Save the value before resetting it in the returnToLanding() function
            sendMessageCXOne({ hasNonSavedChanges: false });
            this.returnToLanding();
            setTimeout(() => {
                this.agGrid.api.redrawRows();
            }, 500);
            if(newObjectiveObject){
                this.toastrManager.showToaster("success", this.getLocalizationString("Objective_Created_Toast", "Objective created successfully"));
            }
            else{
                this.toastrManager.showToaster("success", this.getLocalizationString("Objective_Updated_Toast", "Objective updated successfully"));
            }
            
        }
        else{
            this.showSpinner = false;
            console.log(`Failed to save objectives`);
        }
    }

    /**
     * Fills the ranges for Week based on those inputted for Day.
     * */
    public autoFillWeek(): void {
        for (let i = 0; i < this.inputDisplays[0].length; i++) {
            let dayValue = this.convertFormattedValueToNumber(this.inputDisplays[0][i]);

            this.inputDisplays[1][i] = this.convertNumberToFormattedValue(dayValue * 5);
            this.rangeInputChange(1, i);
        }
        this.enableWeekAutoFill = false;
    }

    /**
     * Fills the ranges for Month based on those inputted for Day.
    * */
    public autoFillMonth(): void {
        for (let i = 0; i < this.inputDisplays[0].length; i++) {
            let dayValue = this.convertFormattedValueToNumber(this.inputDisplays[0][i]);
            this.inputDisplays[2][i] = this.convertNumberToFormattedValue(dayValue * 20);
            this.rangeInputChange(2, i);
        }
        this.enableMonthAutoFill = false;
    }

    /**
     * Converts the specified formatted value into the numeric value it represents based on currentNumericType and currentTimeType.
     * @param formattedValue String in format that matches current selected metric data type
     */
    public convertFormattedValueToNumber(formattedValue: string): number {
        switch (this.currentNumericType) {
            case 0: // Currency
            case 1: // Number
            case 2: // Percent
                return +formattedValue;
            case 3: // Time
                switch (this.currentTimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return +formattedValue;
                    case 4: // Time
                        return this.convertTimeToSeconds(formattedValue);
                    default:
                        return +formattedValue;
                }
            default:
                return +formattedValue;
        }
    }

    /**
     * Converts the specified numeric value into the proper format based on currentNumericType and currentTimeType.
     * @param numericValue Number greater than 0
     */
    public convertNumberToFormattedValue(numericValue: number): string {
        if (numericValue <= 0)
            return "";

        switch (this.currentNumericType) {
            case 0: // Currency
            case 1: // Number
            case 2: // Percent
                return this.roundToTwoDecimalPlaces(numericValue).toString();
            case 3: // Time
                switch (this.currentTimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return numericValue.toString();
                    case 4: // Time
                        return this.formatTime(numericValue);
                    default:
                        return numericValue.toString();
                }
            default:
                return this.roundToTwoDecimalPlaces(numericValue).toString();
        }
    }

    /**
     * Returns the number of seconds represented by a string in HH:MM:SS format.
     * @param timeString String in HH:MM:SS format
     */
    public convertTimeToSeconds(timeString: string): number {
        let [hours, minutes, seconds] = timeString.split(':').map(Number);

        let totalSeconds = 0;
        totalSeconds += hours * 3600;
        totalSeconds += minutes * 60;
        totalSeconds += seconds;

        return totalSeconds;
    }

    public printGroupTypeNames(type: string): string {
        let output = "";
        let allowedGroupTypes = null;
        if(this.currentMetricType == 1){
            output += "- ";
            //If metric min level selected is the bottom include all groups of that type
            if (type == "emp" && this.selectedObjective.assignments.empLevelMin == 1)
                return "- " + this.getLocalizationString("All_Groups", "All Groups");
            else if (type == "rec" && this.selectedObjective.assignments.recLevelMin == 1)
                return "- " + this.getLocalizationString("All_Groups", "All Groups");

            //Carry over only the allowed group types
            if (type == "emp")
                allowedGroupTypes = this.groupTypes[type].filter(item => item.GroupLevel >= this.selectedObjective.assignments.empLevelMin);
            else
                allowedGroupTypes = this.groupTypes[type].filter(item => item.GroupLevel >= this.selectedObjective.assignments.recLevelMin);

            allowedGroupTypes.forEach((item, index: number, arr) => {
                let properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                if (index == arr.length - 1 && arr.length != 1) {
                    output += this.getLocalizationString("And", "And").toLowerCase() + " ";
                } else if (index == arr.length - 1 && arr.length == 1) {
                    properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                }
                output += properName;
                if (index < arr.length - 1) {
                    output += ', ';
                }
            });
        }
        else if(this.currentMetricType == 0 && this.selectedObjective.assignments.coreAssignAtLevel != 0){
            if(type == 'rec' && this.selectedObjective.assignments.recAssignAll && this.selectedObjective.assignments.coreAssignAtType != "rec"){
                output += "- ";
                if (this.selectedObjective.assignments.recLevelMin == 1)
                    return "- " + this.getLocalizationString("All_Groups", "All Groups");

                allowedGroupTypes = this.groupTypes[type].filter(item => item.GroupLevel >= this.selectedObjective.assignments.recLevelMin);
                allowedGroupTypes.forEach((item, index: number, arr) => {
                    let properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                    if (index == arr.length - 1 && arr.length != 1) {
                        output += this.getLocalizationString("And", "And").toLowerCase() + " ";
                    } else if (index == arr.length - 1 && arr.length == 1) {
                        properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                    }
                    output += properName;
                    if (index < arr.length - 1) {
                        output += ', ';
                    }
                });
            }
            else if (type == 'emp' && this.selectedObjective.assignments.empAssignAll && this.selectedObjective.assignments.coreAssignAtType != "emp"){
                output += "- ";
                if (this.selectedObjective.assignments.recLevelMin == 1)
                    return "- " + this.getLocalizationString("All_Groups", "All Groups");

                allowedGroupTypes = this.groupTypes[type].filter(item => item.GroupLevel >= this.selectedObjective.assignments.empLevelMin);
                allowedGroupTypes.forEach((item, index: number, arr) => {
                    let properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                    if (index == arr.length - 1 && arr.length != 1) {
                        output += this.getLocalizationString("And", "And").toLowerCase() + " ";
                    } else if (index == arr.length - 1 && arr.length == 1) {
                        properName = this.getLocalizationString("All", "All") + " " + item.GroupTypeName + " " + this.getLocalizationString("Groups", "Groups");
                    }
                    output += properName;
                    if (index < arr.length - 1) {
                        output += ', ';
                    }
                });
            }
        }

        return output;
    }

    /**
     *  This function searches the columns for empty values. if the whole column is empty it clears all of the red borders for the input boxes in that column
     * */
    private checkForEmptyColumns(): void{
        for (let i = 0; i < 3; i++) {
            let columnCount = 0;
            for (let j = 0; j < this.selectedPalette.LevelCount - 1; j++) {
                if(this.inputDisplays[i][j] == "" || this.inputDisplays[i][j] == null){
                    columnCount++;
                }
            }

            if(columnCount == this.selectedPalette.LevelCount - 1){
                //this means the column is empty and that I can remove the red borders
                for(let x = 0; x < this.selectedPalette.LevelCount - 1; x++){
                    this.displayRedBorder[i][x] = false;
                }
            }
        }
    }

    /**
     *  This function checks the objectiveDetails for null values
     * */
    public checkforEmptyObjectiveDetails(): boolean{

        for(let i = 0; i < this.selectedObjectiveList.length; i++){
            if(this.selectedObjectiveList[i].combinedObj.ObjectiveDetails.some(item => 
                item.dayMinValue == null && item.weekMinValue == null && item.monthMinValue == null)
            ){
                return true;
            }
        }

        return false;
    }

    public openAddEditEmailModal(){
        this.filterActiveUsers();
        this.modalRef = this.modalService.open(this.AddEditEmailNotificationModal, {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            modalDialogClass: 'cx-one-ui modal-center-filter fit-content-modal',
        });

        if(this.selectedObjectiveList[0].combinedObj.AssignedLevel < 6 ) {
            this.selectedObjectiveList.forEach(item => {
                this.alertlevels.push(this.groupTypes[item.assignments.coreAssignAtType][item.assignments.coreAssignAtLevel - 1]);
            });
        }
        if(this.currentMetricType == 1){
            if(this.selectedObjectiveList[0].combinedObj.AssignedLevel == 6){
                this.normalizedMetricPlaceHolder = this.getLocalizationString("All_Groups", "All Groups");
            }
            else{
                this.selectedEmailGrouplevel = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType][this.selectedObjective.assignments.coreAssignAtLevel - 1];
                if(this.selectedObjective.assignments.coreAssignAtType == "emp"){

                    if(this.selectedObjective.assignments.rec.length == 0){
                        this.normalizedMetricPlaceHolder = this.getLocalizationString("Rec_Level", "", this.groupTypes[this.selectedObjective.assignments.coreAssignAtType][this.selectedObjective.assignments.coreAssignAtLevel - 1]?.GroupTypeName);
                    }
                    else{
                        this.normalizedMetricPlaceHolder = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType][this.selectedObjective.assignments.coreAssignAtLevel - 1]?.GroupTypeName;
                    }
                }
                else{
                    if(this.selectedObjective.assignments.emp.length == 0){
                        this.normalizedMetricPlaceHolder = this.getLocalizationString("Emp_Level", "", this.groupTypes[this.selectedObjective.assignments.coreAssignAtType][this.selectedObjective.assignments.coreAssignAtLevel - 1]?.GroupTypeName);
                    }
                    else{
                        this.normalizedMetricPlaceHolder = this.groupTypes[this.selectedObjective.assignments.coreAssignAtType][this.selectedObjective.assignments.coreAssignAtLevel - 1]?.GroupTypeName;
                    }
                }

                if(this.currentAlert != null){
                    this.currentAlert.SendToLevel = this.selectedObjective.assignments.coreAssignAtLevel;
                }
            }
        }
        
        this.isObjectiveChanged();
    }

    public filterActiveUsers() {
        this.activeUsers = this.userList.filter(user => user.Active == true && user.AccountLocked == false);
    }

    public closeAlertModal() {
        this.modalRef.close();
        this.clearEmailAlertObjects();
        this.isObjectiveChanged();
        if(this.duplicateNotification){
            this.duplicateNotification = false;
        }
    }

    public clearEmailAlertObjects() {
        this.selectedEmailGrouplevel = null;
        this.selectedEmailTimeInterval = null;
        this.selectedEmailTimeNumber = null;
        this.selectedUsers = [];
        this.selectedNotificationTypes = [];
        this.selectedExternalEmails = [];
        this.currentAlert = null;
        this.alertlevels = [];
    }

    public saveAlerts(){
        let objectiveInfo = this.selectedObjective.combinedObj;

        let normalized: boolean = this.selectedObjectiveList[this.tabIndex ?? 0].combinedObj.AssignedLevel == 6;

        this.tempNotificationID--;

        if (this.currentAlert == null) {
            let newAlert: ObjectiveAlertDTO = {
                Active: true,
                CompanyID: objectiveInfo.CompanyID,
                IntervalTime: +this.selectedEmailTimeNumber,
                IntervalTimeType: this.selectedEmailTimeInterval.value,
                ObjectiveAlertID: this.tempNotificationID, //Giving them temporary negative IDs so that they can be differentiated when editing them before saving them.
                ObjectiveID: objectiveInfo.ObjectiveID,
                OtherEmails: ""+this.selectedExternalEmails.map(({ value }) => value),
                SendEmail: this.selectedNotificationTypes.some(item => item.value == "Email"),
                SendSystemNote: this.selectedNotificationTypes.some(item => item.value == "System"),
                SendToLevel: normalized ? 1 : this.selectedEmailGrouplevel.GroupLevel,
                SendToRole: 0,
                SendToType: this.selectedObjectiveList[this.tabIndex ?? 0].assignments.coreAssignAtType == "emp" || normalized ? 0 : 1,
                LoginIDs: this.selectedUsers.map(item => item.LoginID)
            }
            this.currentAlert = newAlert;

            let result = this.checkForDuplicateAlert(newAlert);

            if(!result){
                this.curNotificationList.push(this.currentAlert);
                this.toastrManager.showToaster("success", this.getLocalizationString("Notification_Added_Successfully", "Notification added successfully."));
            }
            else{
                this.currentAlert = null;
                return;
            }
        }
        else {
            let previousAlert:ObjectiveAlertDTO = cloneDeep(this.currentAlert);

            this.currentAlert = {
                Active: true,
                CompanyID: objectiveInfo.CompanyID,
                IntervalTime: +this.selectedEmailTimeNumber,
                IntervalTimeType: this.selectedEmailTimeInterval.value,
                ObjectiveAlertID: previousAlert.ObjectiveAlertID,
                ObjectiveID: objectiveInfo.ObjectiveID,
                OtherEmails: ""+this.selectedExternalEmails.map(({ value }) => value),
                SendEmail: this.selectedNotificationTypes.some(item => item.value == "Email"),
                SendSystemNote: this.selectedNotificationTypes.some(item => item.value == "System"),
                SendToLevel: normalized ? 1 : this.selectedEmailGrouplevel.GroupLevel,
                SendToRole: 0,
                SendToType: this.selectedObjectiveList[this.tabIndex ?? 0].assignments.coreAssignAtType == "emp" || normalized ? 0 : 1,
                LoginIDs: this.selectedUsers.map(item => item.LoginID)
            };

            let result = this.checkForDuplicateAlert(this.currentAlert);

            if(!result){
                this.curNotificationList.forEach((item, index, arr) => {
                    if(item.ObjectiveAlertID == this.currentAlert.ObjectiveAlertID){
                        arr[index] = this.currentAlert;
                    }
                });
                this.toastrManager.showToaster("success", this.getLocalizationString("Notification_Updated_Successfully", "Notification updated successfully."));
            }
            else{
                this.currentAlert = previousAlert;
                return;
            }
        }

        this.modalRef.close();
        this.secondSaveDisabled = false;
        this.clearEmailAlertObjects();
        this.notificationGridOptions = null;
        this.notificationSelectedLabel = "0 " + this.getLocalizationString("Selected", "Selected");
        this.cdr.detectChanges();
        this.notificationGridOptions = this.getNotificationGridOptions();
        this.showBackValidationMessage = true;
        this.isObjectiveChanged();
    }

    public invalidTags(): boolean {
        let externalEmailInput = this.tagifyService.get('externalEmailInput');

        if(externalEmailInput == null){
            return false;
        }
        if (externalEmailInput.getTagElms().length != externalEmailInput.value.length){
            return true;
        }
        return false;
    }

    public alertNotificationValid(): boolean {

        //Make sure fields are valid
        if(this.selectedNotificationTypes.length == 0 ||
            (this.selectedEmailGrouplevel == null && this.selectedObjectiveList[this.tabIndex ?? 0].combinedObj.AssignedLevel < 6) ||
            this.selectedEmailTimeInterval == null ||
            (this.selectedEmailTimeNumber <= 0 || isNaN(+this.selectedEmailTimeNumber)) ||
            this.selectedUsers.length == 0 || this.invalidTags()){
                return false;
        }

        //Check for changes
        if(this.currentAlert?.IntervalTime == this.selectedEmailTimeNumber &&
            this.currentAlert?.IntervalTimeType == this.selectedEmailTimeInterval.value &&
            (this.currentAlert?.SendToLevel == this.selectedEmailGrouplevel.GroupLevel) &&
            this.currentAlert?.SendEmail == this.selectedNotificationTypes.some(item => item.value == "Email") && 
            this.currentAlert?.SendSystemNote == this.selectedNotificationTypes.some(item => item.value == "System") &&
            this.currentAlert?.OtherEmails == ""+this.selectedExternalEmails.map(({ value }) => value) &&
            JSON.stringify(this.currentAlert.LoginIDs.sort((a,b) => a - b)) == JSON.stringify(this.selectedUsers.map(item => item.LoginID).sort((a,b) => a - b))){
                return false;
            }

        return true;
    }

    public editAlert(AlertObj: ObjectiveAlertDTO){

        this.currentAlert = this.curNotificationList.filter(item => item.ObjectiveAlertID == AlertObj.ObjectiveAlertID)[0];

        this.selectedEmailGrouplevel = this.groupTypes[this.selectedObjectiveList[this.tabIndex ?? 0].assignments.coreAssignAtType].find(group => group.GroupLevel == this.currentAlert.SendToLevel);

        if(this.currentMetricType == 0)
            this.selectedEmailTimeInterval = this.CountEmailTimeIntervalList.find(item => item.value == this.currentAlert.IntervalTimeType);
        else
            this.selectedEmailTimeInterval = this.NormalizedEmailTimeIntervalList.find(item => item.value == this.currentAlert.IntervalTimeType);


        this.selectedEmailTimeNumber = this.currentAlert.IntervalTime;
        this.selectedUsers = this.userList.filter(user => this.currentAlert.LoginIDs.includes(user.LoginID));
        this.selectedExternalEmails = this.currentAlert.OtherEmails.split(',');

        
        if(this.currentAlert.SendEmail){
            this.selectedNotificationTypes.push(this.NotificationTypeList.find(item => item.value == "Email"))
        }
        if(this.currentAlert.SendSystemNote){
            this.selectedNotificationTypes.push(this.NotificationTypeList.find(item => item.value == "System"))
        }

        this.timeNumberChange(this.currentAlert.IntervalTime);
        this.openAddEditEmailModal();
    }

    public timeNumberChange(e: any) {

        if(this.duplicateNotification){
            this.duplicateNotification = false;
        }

        let singular: boolean = e == 1;
        switch (this.selectedEmailTimeInterval?.value) {
            case 1:
                this.selectedEmailTimeInterval.label = singular ? this.getLocalizationString("Day", "Day") : this.getLocalizationString("Days", "Days");
                break;
            case 2:
                this.selectedEmailTimeInterval.label = singular ? this.getLocalizationString("Week", "Week") : this.getLocalizationString("Weeks", "Weeks");
                break;
            case 3:
                this.selectedEmailTimeInterval.label = singular ? this.getLocalizationString("Month", "Month") : this.getLocalizationString("Months", "Months");
                break;
            case 4:
                this.selectedEmailTimeInterval.label = singular ? this.getLocalizationString("Hour", "Hour") : this.getLocalizationString("Hours", "Hours");
                break;
        }

        if(this.currentMetricType == 0){
            this.CountEmailTimeIntervalList[0].label = singular ? this.getLocalizationString("Day", "Day") : this.getLocalizationString("Days", "Days");
            this.CountEmailTimeIntervalList[1].label = singular ? this.getLocalizationString("Week", "Week") : this.getLocalizationString("Weeks", "Weeks");
            this.CountEmailTimeIntervalList[2].label = singular ? this.getLocalizationString("Month", "Month") : this.getLocalizationString("Months", "Months");
        }
        else{
            this.NormalizedEmailTimeIntervalList[0].label = singular ? this.getLocalizationString("Day", "Day") : this.getLocalizationString("Days", "Days");
            this.NormalizedEmailTimeIntervalList[1].label = singular ? this.getLocalizationString("Week", "Week") : this.getLocalizationString("Weeks", "Weeks");
            this.NormalizedEmailTimeIntervalList[2].label = singular ? this.getLocalizationString("Month", "Month") : this.getLocalizationString("Months", "Months");
            this.NormalizedEmailTimeIntervalList[3].label = singular ? this.getLocalizationString("Hour", "Hour") : this.getLocalizationString("Hours", "Hours");
        }
    }

    /**
     * Sets the ag-grid options for the notification table. Also loads in new data for the table
     */
    public getNotificationGridOptions(): GridOptions {
        let gridOptions: GridOptions = {
            suppressRowClickSelection: true,
            suppressCellFocus: true,
            rowSelection: 'multiple',
            suppressMovableColumns: true,
            suppressContextMenu: true,
            rowClass: 'cxOneRow',
            rowHeight: 36,
            headerHeight: 44,
            defaultColDef: {
                resizable: false,
                suppressMenu: true,
                headerCheckboxSelectionFilteredOnly: true,
                icons: {
                    sortAscending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-up.svg#arrow-up"></use></svg></div>',
                    sortDescending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use></svg></div>',
                },
            },
            columnDefs: [
                {
                    colId: "SendToLevel",
                    field: "SendToLevel",
                    flex: 1,
                    sortable: true,
                    headerName: this.getLocalizationString("Level", "Level"),
                    valueFormatter: (params) => {
                        let str = "";
                        if (params.value != null) {
                            if(this.selectedObjective.assignments.coreAssignAtLevel == 6){
                                str = this.getLocalizationString("All_Groups", "All Groups")
                            }
                            else{
                                if(params.data.SendToType == 0){
                                    str = this.groupTypes["emp"][params.value - 1]?.GroupTypeName
                                }
                                else{
                                    str = this.groupTypes["rec"][params.value - 1]?.GroupTypeName
                                }
                            }
                            
                        }
                        return str;
                    }
                },
                {
                    colId: "IntervalTimeType",
                    field: "IntervalTimeType",
                    flex: 1,
                    sortable: false,
                    headerName: this.getLocalizationString("Consistent_Range", "Consistent Range"),
                    valueFormatter: (params) => {
                        let str = "";

                        if(this.metricAbrDict[this.selectedObjective.MetricID].Direction == 1){
                            str = this.getLocalizationString("Lowest", "Lowest");
                        }
                        else{
                            str = this.getLocalizationString("Highest", "Highest");
                        }
                        
                        return str;
                    }
                },
                {
                    colId: "IntervalTime",
                    field: "IntervalTime",
                    flex: 1,
                    sortable: true,
                    headerName: this.getLocalizationString("Amount_Of_Time", "Amount of time"),
                    valueFormatter: (params) => {
                        let str = "";

                        if (params.value != null) {
                            if(params.value > 1){
                                //this is for the plural versions of the words
                                if(params.data.IntervalTimeType == 1){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Days", "Days");
                                }
                                if(params.data.IntervalTimeType == 2){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Weeks", "Weeks");
                                }
                                if(params.data.IntervalTimeType == 3){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Months", "Months");
                                }
                                if(params.data.IntervalTimeType == 4){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Hours", "Hours");
                                }
                            }
                            else{
                                //non pluralized
                                if(params.data.IntervalTimeType == 1){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Day", "Day");
                                }
                                if(params.data.IntervalTimeType == 2){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Week", "Week");
                                }
                                if(params.data.IntervalTimeType == 3){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Month", "Month");
                                }
                                if(params.data.IntervalTimeType == 4){
                                    return str += params.value.toString() + " " + this.getLocalizationString("Hour", "Hour");
                                }
                            }
                        }
                        
                        return str;
                    }
                },
                {
                    colId: "SendSystemNote",
                    field: "SendSystemNote",
                    flex: 1,
                    sortable: true,
                    headerName: this.getLocalizationString("Notification_Type", "Notification type"),
                    valueGetter: (params) => {
                        let str = "";
                        if (params != null) {
                            if(params.data.SendEmail && params.data.SendSystemNote){
                                str = this.getLocalizationString("Email_System", "Email, System");
                            }
                            else if(params.data.SendEmail && !params.data.SendSystemNote){
                                str = this.getLocalizationString("Email", "Email");
                            }
                            else if(!params.data.SendEmail && params.data.SendSystemNote){
                                str = this.getLocalizationString("System", "System");
                            }
                            else{
                                str = "undefined"
                            }
                        }
                        return str;
                    }
                },
                {
                    colId: "Users",
                    field: "Users",
                    flex: 2,
                    sortable: false,
                    headerName: this.getLocalizationString("Users", "Users"),
                    cellRenderer: 'customTooltipCellRenderer'
                },
                {
                    colId: "OtherEmails",
                    field: "OtherEmails",
                    flex: 2,
                    sortable: false,
                    headerName: this.getLocalizationString("External_Emails", "External Emails"),
                    cellRenderer: 'customTooltipCellRenderer'
                },
                {
                    cellRenderer: 'notificationEditCellRenderer', 
                    width: 50,
                    sortable: false
                },
            ],
            overlayNoRowsTemplate: `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                        <svg class="cxoneFavoriteState mb-2">
                                            <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                        </svg>
                                        <p class="cxone-error-text">${this.getLocalizationString("No_Notification", "No notification added yet")}</p>
                                    </div>`,
            onGridReady: (params) => {
                params.api.setGridOption('rowData', []);
                params.api.setGridOption('rowData', this.curNotificationList);
            },
            components: {
                customTooltipCellRenderer: CustomTooltipCellRendererComponent, 
                notificationEditCellRenderer: NotificationEditCellRendererComponent
            },
            onRowDataUpdated: (event: RowDataUpdatedEvent) => {
                this.updateNotificationLabel(event.api);
            },
            onFilterChanged: (event) => {
                this.updateNotificationLabel(event.api);
            },
            context: {
                EditAlert: ($event) => this.editAlert($event),
                getUserList: () => this.userList
            },
            onSelectionChanged: (event) => {
                let selectedCount = event.api.getSelectedRows().length;
                let selectedLabel = " " + this.getLocalizationString("Selected", "Selected");
                this.notificationSelectedLabel = `${selectedCount} ${selectedLabel}`;
            },
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: (node) => {

                let result: any;
                if(this.filterLevelSelection.length > 0 && this.filterNotificationTypeSelection.length > 0){
                    result = this.doesExternalFilterPassWithFilters(node, this.notificationSearchText, this.filterLevelSelection, this.filterNotificationTypeSelection);
                }
                else if(this.filterLevelSelection.length > 0 && this.filterNotificationTypeSelection.length == 0){
                    result = this.doesExternalFilterPassWithFilters(node, this.notificationSearchText, this.filterLevelSelection);
                }
                else if(this.filterLevelSelection.length == 0 && this.filterNotificationTypeSelection.length > 0){
                    result = this.doesExternalFilterPassWithFilters(node, this.notificationSearchText, [], this.filterNotificationTypeSelection);
                }
                else{
                    result = this.doesExternalFilterPassWithFilters(node, this.notificationSearchText);
                }

                return result;
            },
        };

        if (this.editPhase == 2)
            for (let i = 0; i < gridOptions.columnDefs.length; ++i) {
                if ((gridOptions.columnDefs[i] as ColDef).hide)
                    continue;
                (gridOptions.columnDefs[i] as ColDef).headerCheckboxSelection = true;
                (gridOptions.columnDefs[i] as ColDef).checkboxSelection = true;
                break;
            }

        return gridOptions;
    }

    /**
     * updates the label for the amount of rows in the ag-grid. 
     * @param api this is api options for the notification ag-grid
     */
    public updateNotificationLabel(api: GridApi) {
        let notificationCount = api.getDisplayedRowCount();
        let notificationLabel = "";

        if(notificationCount == 1){
            notificationLabel = this.getLocalizationString("Notification", "Notification");
        }
        else{
            notificationLabel = this.getLocalizationString("Notifications", "Notifications");
        }
        
        if (notificationLabel != "")
            this.notificationsLabel = `${notificationCount} ${notificationLabel}`;
        else
            this.notificationsLabel = notificationLabel;

        if (api.getDisplayedRowCount() == 0)
            api.showNoRowsOverlay();
        else
            api.hideOverlay();
    }

    /**
     * loops through the selectedObjectiveList and gets all of the alerts
     */
    public setUpNotificationTableData(): ObjectiveAlertDTO[]{

        let tempList: ObjectiveAlertDTO[] = [];

        this.selectedObjectiveList.forEach(objective => {
            objective.combinedObj.AlertsList.forEach(alertRow => {
                alertRow.forEach(alert => {
                    tempList.push(alert);
                });
            });
        });

        return tempList;
    }

    /**
     * Removes selected rows from notification table and from selectedObjectiveList
     */
    public removeSelectedNotifications(){
        let selectedRows: ObjectiveAlertDTO[] = this.agGridAlert?.api?.getSelectedRows();
        let selectedIds = selectedRows.map(item => item.ObjectiveAlertID);
        this.curNotificationList = this.curNotificationList.filter(item => !selectedIds.includes(item.ObjectiveAlertID));
        this.notificationGridOptions = null;
        this.notificationSelectedLabel = "0 " + this.getLocalizationString("Selected", "Selected");
        this.secondSaveDisabled = false;
        this.cdr.detectChanges();
        this.notificationGridOptions = this.getNotificationGridOptions();
        this.showBackValidationMessage = true;
        this.toastrManager.showToaster("success", this.getLocalizationString("Notification_Deleted_Successfully", "Notification deleted successfully."));
    }

    public isRemoveButtonDisabled() {
        if (!(this.agGridAlert?.api) || this.agGridAlert?.api.getSelectedRows()?.length == 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * function to set the search text and then call the onFilterChanged for the notifications ag-grid
     * @param searchText string for search text
     */
    public onNotificationsSearchChange(searchText) {
        this.notificationSearchText = searchText;
        if (this.agGridAlert?.api != undefined){
            this.agGridAlert.api.onFilterChanged();
        }
    }

    /**
     * function to set the Level filter on the notification omnibar
     */
    private setFilterOptions() {
        this.filterLevelOptions = [];
        this.selectedObjectiveList.forEach(item => {
            this.filterLevelOptions.push(this.groupTypes[item.assignments.coreAssignAtType][item.assignments.coreAssignAtLevel - 1]);
        });
    }

    /**
     * function to clear omnibar filters
     */
    public clearFilters(){
        this.filterLevelSelection = [];
        this.filterNotificationTypeSelection = [];
        this.cdr.detectChanges();
        this.agGridAlert?.api?.onFilterChanged();
    }

    /**
     * function to close the filters section on the notification table
     */
    public closeFilters(){
        this.filters.toggleFiltersSection();
    }

    /**
     * Function for the ag-grid filtering that uses both the dropdowns and the search bar. Had to make this custom
     * @param node this is the row data that is being checked
     * @param searchValue string for the text in the search bar
     * @param filterLevels array for the Levels selected in the levels dropdown
     * @param filterNotificationType array for the Notification types selected in the Notification type dropdown
     */
    public doesExternalFilterPassWithFilters = (node: IRowNode, searchValue: string, filterLevels?: GroupTypeDTO[], filterNotificationType?: NotificationTypeModel[]) => {
        let passLevels = false;
        let passType = false;

        if(filterLevels != null && filterLevels.length != 0){
            for(let i = 0; i < filterLevels.length; i++){
                if(node.data.SendToLevel == filterLevels[i].GroupLevel){
                    passLevels = true;
                }
            }
        }
        else{
            passLevels = true;
        }

        if(filterNotificationType != null){
            for(let i = 0; i < filterNotificationType.length; i++){
                if(node.data.SendEmail && filterNotificationType[i].type == "Email"){
                    passType = true;
                }
                if(node.data.SendSystemNote && filterNotificationType[i].type == "System"){
                    passType = true;
                }
            }
        }
        else{
            passType = true;
        }

        if(passLevels && passType){
           // This function gets all the column objects, filters only to the visible columns...
            const columnApi: ColumnApi = node['beans'].columnApi;
            const gridApi: GridApi = node['beans'].gridApi;
            const filterValueLowercase = searchValue.toLowerCase();
            const visibleColumns = columnApi.getColumns().filter(col => col.isVisible());

            // ...and looks for a substring match in each of the column's values (after transforming to a lowercase string):
            return undefined !== visibleColumns.find((col) => {
                if(col.getColId() == "Users"){
                    //here I have to do a different search for Users specifically
                    let result = this.searchUsers(node.data.LoginIDs, searchValue);
                    return result;
                }
                else{
                    let nodeValue = gridApi.getValue(col, node);
                    if (nodeValue == null)
                        nodeValue = "";

                    if (typeof nodeValue !== 'string') {
                        const colDef = col.getColDef();
                        const params: ValueFormatterParams = {
                            api: gridApi,
                            node,
                            data: node.data,
                            colDef,
                            column: col,
                            columnApi,
                            context: node['beans'].context,
                            value: nodeValue,
                        };

                        if (typeof colDef.valueFormatter !== 'string')
                            nodeValue = colDef.valueFormatter?.(params);
                    }

                    const stringNodeValue = "" + nodeValue; // ensure other non-string, non-null values are strings.
                    return stringNodeValue.toLowerCase().includes(filterValueLowercase);
                }
                
            }); 
        }
        else{
            return false;
        }
    }

    private searchUsers(loginIDs: number[], searchValue: string): boolean{
        let result = false
        loginIDs.forEach(id => {
            let user = this.userList.find(user => user.LoginID == id);

            if(user.LoginName.toLowerCase().includes(searchValue.toLowerCase())){
                result = true;
            }
        });

        return result;
    }

    public isOverflowing(): boolean {
        const el = document.querySelector('.text-input') as HTMLInputElement;
        return el.scrollWidth >= el.clientWidth;
    }

    public checkForDuplicateAlert(newAlert: ObjectiveAlertDTO) {

        this.duplicateNotification = false;

        this.curNotificationList.forEach(alert => {

            if (
                (alert.Active == newAlert.Active &&
                alert.CompanyID == newAlert.CompanyID &&
                alert.IntervalTime == +newAlert.IntervalTime &&
                alert.IntervalTimeType == newAlert.IntervalTimeType &&
                alert.SendToLevel == newAlert.SendToLevel &&
                alert.SendToRole == newAlert.SendToRole &&
                alert.SendToType == newAlert.SendToType &&
                (alert.SendEmail == newAlert.SendEmail || alert.SendSystemNote == newAlert.SendSystemNote) &&
                alert.OtherEmails == newAlert.OtherEmails &&
                this.loginArrayComparison(alert.LoginIDs, newAlert.LoginIDs) && alert.ObjectiveAlertID != newAlert.ObjectiveAlertID)
            ) {
                this.duplicateNotification = true;
            }

        });

        return this.duplicateNotification;
    }

    private loginArrayComparison(arr1: number[], arr2: number[]): boolean {
        // Check if arrays have the same length
        if (arr1.length !== arr2.length) {
          return false;
        }
      
        // Sort the arrays
        const sortedArr1 = arr1.slice().sort();
        const sortedArr2 = arr2.slice().sort();
      
        // Compare sorted arrays
        for (let i = 0; i < sortedArr1.length; i++) {
          if (sortedArr1[i] !== sortedArr2[i]) {
            return false;
          }
        }
      
        return true;
    }

    public notificationChanged(){
        if(this.duplicateNotification){
            this.duplicateNotification = false;
        }
    }

    public limitCharacterLength(event: any, column: number): boolean {
        
        let length: number = this.metricAbrDict[this.selectedObjective.MetricID].TimeType == 4 ? +event.target.value.split(":")[0].length : event.target.value.length;

        switch (column) {
            case 0:
                return length < 5;
            case 1:
                return length < 6;
            case 2:
                return length < 7;
            default:
                return;

        }
    }

    public checkCreateForChanges(){
        //this is for the edit case
        if(this.selectedObjective.MetricID != 0 || this.selectedObjective.ObjectiveName != ""){
            sendMessageCXOne({ hasNonSavedChanges: true });
            return;
        }

        sendMessageCXOne({ hasNonSavedChanges: false });
    }
}
